/* eslint-disable no-unused-vars */
import { Fragment, useEffect, useRef, useState } from "react";
import { createClient } from "@supabase/supabase-js";
import toast from "react-hot-toast";
import axios from "axios";
import { formCompanies } from "../../data/formCompanies";
import { formBanks } from "../../data/formBanks";
import { formatDate as formatDateUtil, validarDNIoNIF, validarTelefono, buscarDNIEnBaserow } from '../../utils'
import { FormGastos2 } from "./FormGastos2";
import { useTranslation } from "react-i18next";
import propTypes from "prop-types";
import { saveAs } from "file-saver";
import { FileInputWithCheckbox } from "../FileInputCheckBox";
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import DocumentUploadForm from './DocumentUploadForm';
import { buscarNumeroNegocioBaserow } from "../../utils/buscarNumeroNegocioBaserow";
import { Checkbox } from "flowbite-react";
import DocumentosExtrajudicialForm from "./components/DocumentosExtrajudicialForm";
import QuickFormNavigation from "./components/QuickFormNavigation";
import FormReiteracionGastos from './FormReiteracionGastos';
import { ApudConfirmationModal } from '../modals/ApudConfirmationModal';

export const FormGastos = ({ step1Loading, setStep1Loading, setCurrentStep }) => {
    const { t } = useTranslation();
    const [formType, setFormType] = useState('extrajudicial'); // extrajudicial | demanda | reiteracion
    const [cantidadPersonasGE, setCantidadPersonasGE] = useState(1);
    const [numeroNegocioGastos, setNumeroNegocioGastos] = useState('');
    const [formValues, setFormValues] = useState({});
    const [step, setStep] = useState(1);
    const [hubspotData, setHubspotData] = useState({});
    const [tasacionBloqueGastos, setTasacionBloqueGastos] = useState('');
    const [extrajudicialFilesProcessed, setExtrajudicialFilesProcessed] = useState(false);
    const [dniFrontFile, setDniFrontFile] = useState(null);
    const [dniFrontFile2, setDniFrontFile2] = useState(null);
    const [dniBackFile, setDniBackFile] = useState(null);
    const [dniBackFile2, setDniBackFile2] = useState(null);
    const [notaryFile, setNotaryFile] = useState(null);
    const [notaryFileAdditional, setNotaryFileAdditional] = useState(null);
    const [registryFile, setRegistryFile] = useState(null);
    const [registryFileAdditional, setRegistryFileAdditional] = useState(null);
    const [agencyFile, setAgencyFile] = useState(null);
    const [agencyFileAdditional, setAgencyFileAdditional] = useState(null);
    const [appraisalFile, setAppraisalFile] = useState(null);
    const [appraisalFileAdditional, setAppraisalFileAdditional] = useState(null);
    const [mortgageDeedFile, setMortgageDeedFile] = useState(null);
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [processValidationComplete, setProcessValidationComplete] = useState(false);
    const [sendApud, setSendApud] = useState(true);
    const [repartoGastos, setRepartoGastos] = useState(false);
    const [certificadoCargas, setCertificadoCargas] = useState(false);
    const [clausulaBis, setClausulaBis] = useState(false);
    const [negocioData, setNegocioData] = useState(null);
    const [experimental, setExperimental] = useState(false);
    const [autoFill, setAutoFill] = useState({
        'cantidad_personas': 1,
        'numero_negocio_gastos': '',
        'nprotocolo_gastos': '',
        'fecha_inicio_prestamo_gastos': '',
        'fecha_extrajudicial_gastos': '',
        'notario_gastos': '',
        'nombre_y_apellidos_gastos': '',
        'nombre': '',
        'dni_gastos': '',
        'direccion_gastos': '',
        'codigo_postal_gastos': '',
        'provincia_gastos': '',
        'banco_gastos': '',
        'datos_banco_gastos': '',
        'gastos_notaria_gastos': 0,
        'gastos_notaria_gastos_adicional': 0,
        'gastos_registro_gastos': 0,
        'gastos_registro_gastos_adicional': 0,
        'gastos_gestoria_gastos': 0,
        'gastos_gestoria_gastos_adicional': 0,
        'gastos_tasacion_gastos': 0,
        'gastos_tasacion_gastos_adicional': 0,
        'porcentaje_cobro_gastos': 12,
        'email_gastos': '',
        'id_negocio': '',
        'telefono_gastos': '',
        'tipo_adquisicion_gastos': 'la adquisición de Vivienda, adquirida el mismo día en Escritura autorizada por el mismo notario.',
        'clausula_gastos': 'Quinta',
        'clausula_texto_gastos': '',
        'clausula_bis_gastos': '',
        'clausula_bis_texto_gastos': '',
        'telefono2_gastos': '',
        'nombre_y_apellidos2_gastos': '',
        'dni2_gastos': '',
        'juzgado_especifico_gastos': 'Juzgado especializado en ACCIONES INDIVIDUALES A LAS CONDICIONES GENERALES DE LA CONTRATACIÓN de la Provincia de XXXX, de acuerdo con el artículo 98.2 LOPJ y por ser el domicilio del demandante de acuerdo con el 52.2.14 de la Ley de Enjuiciamiento Civil',
        'documento_notaria_gastos': 'documento número 3',
        'documento_registro_gastos': 'documento número 4',
        'documento_gestoria_gastos': 'documento número 5',
        'documento_reclamacion_gastos': 'documento número 6',
        'documento_extrajudicial_gastos': 'documento número 7',
        'documento_tasacion_gastos': 'documento número 8',

    });
    // Usar formCompanies o formBanks según si es demanda de gastos o no
    const companies = formType === 'demanda' ? formBanks : formCompanies;
    const formatDate = formatDateUtil;
    const validacionDNIoNIF = validarDNIoNIF;
    const validacionTelefono = validarTelefono;
    const inputRef = useRef();
    const postalCodeRef = useRef();
    const provinciaRef = useRef();

    const [contratoFile, setContratoFile] = useState(null);
    const [apudFile, setApudFile] = useState(null);
    const [reclamacionFile, setReclamacionFile] = useState(null);
    const [selectedBank, setSelectedBank] = useState(null);
    const [absorbedBanks, setAbsorbedBanks] = useState([]);
    const [selectedAbsorbedBank, setSelectedAbsorbedBank] = useState('');
    const [oneFile, setOneFile] = useState(true);
    const [documentosValidados, setDocumentosValidados] = useState(false);
    const [validationResults, setValidationResults] = useState(null);
    const [extractedData, setExtractedData] = useState(null);
    const [showApudModal, setShowApudModal] = useState(false);
    const [pendingApudDate, setPendingApudDate] = useState(null);
    const [fechaError, setFechaError] = useState('');

    const handleBankChange = (e) => {
        if (formType === 'demanda') {
            // Para demanda de gastos, usar formBanks
            const selectedBank = formBanks.find(company => company.name === e.target.value);
            setSelectedBank(selectedBank);
            setAutoFill({ ...autoFill, [e.target.name]: e.target.value });

            // Actualizar los bancos absorbidos cuando se selecciona un banco
            if (selectedBank && selectedBank.absorbedBanks && selectedBank.absorbedBanks.length > 0) {
                setAbsorbedBanks(selectedBank.absorbedBanks);
            } else {
                setAbsorbedBanks([]);
                setSelectedAbsorbedBank('');
            }
        } else {
            // Para extrajudicial, usar formCompanies
            const selectedBank = formCompanies.find(company => company.name === e.target.value);
            setSelectedBank(selectedBank);
            setAutoFill({ ...autoFill, [e.target.name]: e.target.value });
            setAbsorbedBanks([]);
            setSelectedAbsorbedBank('');
        }
    };

    // Función helper para actualizar banco y bancos absorbidos cuando se autocompleta desde BD
    const updateBankAndAbsorbedBanks = (bankName) => {
        if (!bankName) {
            setSelectedBank(null);
            setAbsorbedBanks([]);
            setSelectedAbsorbedBank('');
            return;
        }

        if (formType === 'demanda') {
            // Para demanda de gastos, usar formBanks
            const selectedBank = formBanks.find(company => company.name === bankName);
            setSelectedBank(selectedBank);

            // Actualizar los bancos absorbidos cuando se selecciona un banco
            if (selectedBank && selectedBank.absorbedBanks && selectedBank.absorbedBanks.length > 0) {
                setAbsorbedBanks(selectedBank.absorbedBanks);
            } else {
                setAbsorbedBanks([]);
                setSelectedAbsorbedBank('');
            }
        } else {
            // Para extrajudicial, usar formCompanies
            const selectedBank = formCompanies.find(company => company.name === bankName);
            setSelectedBank(selectedBank);
            setAbsorbedBanks([]);
            setSelectedAbsorbedBank('');
        }
    };

    const handleProvinceChange = (e) => {
        const province = e.target.value;
        setAutoFill(prevState => ({
            ...prevState,
            provincia_gastos: province,
            juzgado_especifico_gastos: `Juzgado especializado en ACCIONES INDIVIDUALES A LAS CONDICIONES GENERALES DE LA CONTRATACIÓN de la Provincia de ${province}, de acuerdo con el artículo 98.2 LOPJ y por ser el domicilio del demandante de acuerdo con el 52.2.14 de la Ley de Enjuiciamiento Civil`
        }));
    };

    //Función para manejar errores
    const handleError = (error, setStep1Loading) => {
        console.log(error);
        toast.error("Ha ocurrido un error inesperado");
        setStep1Loading(false);
    };

    //Función para manejar la descarga de archivos
    const downloadFile = async (response, index, setFileFunction) => {
        const url = "https://api.office.coventia.es/media/generated/" + response.data.documentos_generados[index];
        const resp = await fetch(url);
        const blob = await resp.blob();
        const fileName = response.data.documentos_generados[index];
        saveAs(blob, fileName);
        setFileFunction({ name: fileName, blob: blob });
    }

    //Use Effect para usar la api google places
    useEffect(() => {
        const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current);
        autocomplete.setComponentRestrictions({
            'country': ['es']
        });
        autocomplete.setFields(['address_component']);

        autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();
            var city = '';
            var country = '';
            var province = '';
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (addressType == 'locality') {
                    city = place.address_components[i]['long_name'];
                }
                if (addressType == 'country') {
                    country = place.address_components[i]['long_name'];
                }
                if (addressType == 'administrative_area_level_2') {
                    province = place.address_components[i]['long_name'];
                }
            }
            var address = inputRef.current.value;
            var index = address.indexOf(city);
            if (index >= 0) {
                address = address.substr(0, index);
            }
            index = address.indexOf(country);
            if (index >= 0) {
                address = address.substr(0, index);
            }
            inputRef.current.value = address;
            provinciaRef.current.value = province;
            setAutoFill(prevState => ({
                ...prevState,
                direccion_gastos: address,
                provincia_gastos: province,
                juzgado_especifico_gastos: `Juzgado especializado en ACCIONES INDIVIDUALES A LAS CONDICIONES GENERALES DE LA CONTRATACIÓN de la Provincia de ${province}, de acuerdo con el artículo 98.2 LOPJ y por ser el domicilio del demandante de acuerdo con el 52.2.14 de la Ley de Enjuiciamiento Civil`
            }));
        });

        autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();
            var postal_code = '';
            for (var i = 0; i < place.address_components.length; i++) {
                for (var j = 0; j < place.address_components[i].types.length; j++) {
                    if (place.address_components[i].types[j] == "postal_code") {
                        postal_code = place.address_components[i].long_name;
                    }
                }
            }
            postalCodeRef.current.value = postal_code;
            setAutoFill(prevState => ({ ...prevState, codigo_postal_gastos: postal_code }));
        });
    }, [step, documentosValidados, formType, extrajudicialFilesProcessed]);
    //Efecto para actualizar los datos del banco cuando es autocompletado
    useEffect(() => {
        if (autoFill.banco_gastos) {
            const selectedBank = formBanks.find(company => company.name === autoFill.banco_gastos);
            setSelectedBank(selectedBank);

            // Actualiza los bancos absorbidos automáticamente si existen
            if (selectedBank && selectedBank.absorbedBanks && selectedBank.absorbedBanks.length > 0) {
                setAbsorbedBanks(selectedBank.absorbedBanks);
            } else {
                setAbsorbedBanks([]);
                setSelectedAbsorbedBank('');
            }
        } else {
            setSelectedBank(null);
            setAbsorbedBanks([]);
            setSelectedAbsorbedBank('');
        }
    }, [autoFill.banco_gastos]);

    const handleInputChangeProtocol = (event) => {
        setNumeroNegocioGastos(event.target.value);
        setAutoFill({ ...autoFill, [event.target.name]: event.target.value });
    };

    // Normaliza un importe a formato numérico con punto decimal (ej: "200.00").
    // Acepta coma o punto decimal y devuelve "0.00" si no hay valor válido.
    const formatImporteAdicional = (valor) => {
        const num = Number(String(valor ?? '').replace(',', '.'));
        return isNaN(num) ? '0.00' : num.toFixed(2);
    };

    // Añade al FormData los 4 importes adicionales (notaria, registro, gestoria, tasacion).
    // El backend los espera siempre; si no llegan los toma como 0 y el cálculo de la minuta sale mal.
    const appendGastosAdicionales = (formData) => {
        formData.set('gastos_notaria_gastos_adicional', formatImporteAdicional(autoFill.gastos_notaria_gastos_adicional));
        formData.set('gastos_registro_gastos_adicional', formatImporteAdicional(autoFill.gastos_registro_gastos_adicional));
        formData.set('gastos_gestoria_gastos_adicional', formatImporteAdicional(autoFill.gastos_gestoria_gastos_adicional));
        formData.set('gastos_tasacion_gastos_adicional', formatImporteAdicional(autoFill.gastos_tasacion_gastos_adicional));
    };

    async function handleSubmit(event) {
        event.preventDefault()
        
        // Verificar si hay errores de fecha antes de enviar
        if (fechaError) {
            toast.error('Por favor, corrige los errores en la fecha antes de continuar');
            return;
        }
        
        setStep1Loading(true)
        if (formType === 'extrajudicial') {
            try {
                //Introducir los datos del formulario en el estado formValues
                setFormValues({
                    cantidad_personas: event.target["cantidad_personas_gastos"].value,
                    nombre: event.target["nombre_y_apellidos_gastos"].value,
                    email: event.target["email_gastos"].value,
                    id_negocio: event.target["numero_negocio_gastos"].value,
                    nombre2: event.target["nombre_y_apellidos2_gastos"].value || null
                });

                setHubspotData({
                    "tipo_formulario": "gastos",
                    "dni": event.target["dni_gastos"].value,
                    "direccion": event.target["direccion_gastos"].value,
                    "banco_origen": event.target["banco_gastos"].value,
                    "fecha_inicio_prestamo": event.target["fecha_inicio_prestamo_gastos"].value,
                    "id_negocio": event.target["numero_negocio_gastos"].value,
                });

                let formData = new FormData(event.target);
                if (dniFrontFile?.file) {
                    formData.set('dni_front_gastos', dniFrontFile.file);
                }
                if (dniBackFile?.file) {
                    formData.set('dni_back_gastos', dniBackFile.file);
                }
                if (dniFrontFile2?.file) {
                    formData.set('dni_front2_gastos', dniFrontFile2.file);
                }
                if (dniBackFile2?.file) {
                    formData.set('dni_back2_gastos', dniBackFile2.file);
                }

                if (notaryFile?.file) {
                    formData.set('inotaria_gastos', notaryFile.file);
                }
                if (notaryFileAdditional?.file) {
                    formData.set('inotaria_adicional_gastos', notaryFileAdditional.file);
                }
                if (registryFile?.file) {
                    formData.set('iregistro_gastos', registryFile.file);
                }
                if (registryFileAdditional?.file) {
                    formData.set('iregistro_adicional_gastos', registryFileAdditional.file);
                }
                if (agencyFile?.file) {
                    formData.set('igestoria_gastos', agencyFile.file);
                }
                if (agencyFileAdditional?.file) {
                    formData.set('igestoria_adicional_gastos', agencyFileAdditional.file);
                }
                if (appraisalFile?.file) {
                    formData.set('itasacion_gastos', appraisalFile.file);
                }
                if (appraisalFileAdditional?.file) {
                    formData.set('itasacion_adicional_gastos', appraisalFileAdditional.file);
                }
                formData.set("tipo_formulario", "gastos_extrajudicial")
                formData.set("send_apud", sendApud)
                formData.set("fecha_inicio_prestamo_gastos", formatDate(event.target["fecha_inicio_prestamo_gastos"].value))
                appendGastosAdicionales(formData)

                const supabaseClient = createClient(
                    'https://uoclqlfzojdjrhcqhgef.supabase.co',
                    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVvY2xxbGZ6b2pkanJoY3FoZ2VmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTc3MDEzMDMsImV4cCI6MjAxMzI3NzMwM30.6VY6hK2MWHngYFt3AP9MkV_1hC0xOIuX0CbYIsC5DT0'
                )

                const { data, error } = await supabaseClient.auth.getSession()
                const access_token = data.session.access_token
                axios.post("https://api.office.coventia.es/enviar-datos-gastos-extrajudicial/", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': access_token
                    }
                }).then(async (response) => {
                    try {
                        const baseUrl = "https://api.office.coventia.es/media/generated/";

                        // Función auxiliar para identificar el tipo de documento
                        const identificarTipoDocumento = (fileName) => {
                            fileName = fileName.toLowerCase();
                            if (fileName.includes('contrato') && fileName.endsWith('.pdf')) return 'contrato';
                            if (fileName.includes('apud') && fileName.endsWith('.pdf')) return 'apud';
                            if (fileName.includes('demanda')) return 'demanda';
                            if (fileName.includes('reclamacion') && fileName.endsWith('.pdf')) return 'reclamacion';
                            return null;
                        };

                        // Objeto para almacenar los blobs por tipo
                        const documentBlobs = {
                            contrato: null,
                            apud: null
                        };

                        // Descargar y procesar todos los documentos
                        const downloadPromises = response.data.documentos_generados.map(async (fileName) => {
                            const url = baseUrl + fileName;
                            const blob = await fetch(url).then(resp => resp.blob());

                            // Solo procesar PDFs para contrato y apud
                            const tipoDocumento = identificarTipoDocumento(fileName);
                            if ((tipoDocumento === 'contrato' || tipoDocumento === 'apud' || tipoDocumento === 'reclamacion') && fileName.toLowerCase().endsWith('.pdf')) {
                                documentBlobs[tipoDocumento] = {
                                    blob: blob,
                                    name: fileName
                                };
                            }

                            return saveAs(blob, fileName);
                        });

                        await Promise.all(downloadPromises);

                        // Setear los archivos para el FormGastos2
                        if (documentBlobs.contrato) {
                            setContratoFile(documentBlobs.contrato);
                        }
                        if (documentBlobs.apud) {
                            setApudFile(documentBlobs.apud);
                        }
                        if (documentBlobs.reclamacion) {
                            setReclamacionFile(documentBlobs.reclamacion);
                        }

                        toast.success(t("¡Archivos descargados correctamente!"));
                        setStep1Loading(false);

                        if (numeroNegocioGastos !== '' && numeroNegocioGastos !== null && numeroNegocioGastos !== undefined && formType !== 'demanda') {
                            setStep(2);
                        }
                    } catch (error) {
                        handleError(error, setStep1Loading);
                        console.log(error);
                        toast.error(t("Ha ocurrido un error inesperado"));
                        setStep1Loading(false);
                    }
                }).catch((error) => {
                    handleError(error, setStep1Loading);
                    console.log(error);
                    toast.error(t("Ha ocurrido un error inesperado"));
                    setStep1Loading(false);
                });
            }
            catch (error) {
                handleError(error, setStep1Loading);
                console.log(error);
                toast.error(t("Ha ocurrido un error inesperado"));
                setStep1Loading(false);
            }
        } else {
            setFormValues({
                cantidad_personas: event.target["cantidad_personas_gastos"].value,
                nombre: event.target["nombre_y_apellidos_gastos"].value,
                nombre2: event.target["nombre_y_apellidos2_gastos"].value || null,
                id_negocio: event.target["numero_negocio_gastos"].value,
            });

            setHubspotData({
                "tipo_formulario": "gastos_judicial",
                "dni": event.target["dni_gastos"].value,
                "direccion": event.target["direccion_gastos"].value,
                "banco_origen": event.target["banco_gastos"].value,
                "fecha_inicio_prestamo": event.target["fecha_inicio_prestamo_gastos"].value,
                "id_negocio": event.target["numero_negocio_gastos"].value,
            });

            let formData = new FormData(event.target);
            formData.set("tipo_formulario", "gastos_judicial")
            formData.set("fecha_inicio_prestamo_gastos", formatDate(event.target["fecha_inicio_prestamo_gastos"].value))
            formData.set("fecha_extrajudicial_gastos", formatDate(event.target["fecha_extrajudicial_gastos"].value))
            formData.set("one_file", oneFile)
            formData.set("send_apud", sendApud)
            formData.set("total_gastos", autoFill.total_gastos)
            formData.set("reparto_gastos", repartoGastos)
            formData.set("certificado_cargas", certificadoCargas)
            formData.set("clausula_bis", clausulaBis)
            appendGastosAdicionales(formData)


            const supabaseClient = createClient(
                'https://uoclqlfzojdjrhcqhgef.supabase.co',
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVvY2xxbGZ6b2pkanJoY3FoZ2VmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTc3MDEzMDMsImV4cCI6MjAxMzI3NzMwM30.6VY6hK2MWHngYFt3AP9MkV_1hC0xOIuX0CbYIsC5DT0'
            )

            const { data, error } = await supabaseClient.auth.getSession()
            const access_token = data.session.access_token
            axios.post("https://api.office.coventia.es/enviar-datos-gastos-judicial/", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': access_token
                }
            }).then(async (response) => {
                try {
                    const baseUrl = "https://api.office.coventia.es/media/generated/";

                    // Función auxiliar para identificar el tipo de documento por su nombre
                    const identificarTipoDocumento = (fileName) => {
                        fileName = fileName.toLowerCase();
                        if (fileName.includes('contrato') && fileName.endsWith('.pdf')) return 'contrato';
                        if (fileName.includes('apud') && fileName.endsWith('.pdf')) return 'apud';
                        if (fileName.includes('demanda')) return 'demanda';
                        return null;
                    };

                    const documentBlobs = {
                        contrato: null,
                        apud: null
                    };

                    // Descargar y procesar todos los documentos
                    const downloadPromises = response.data.documentos_generados.map(async (fileName) => {
                        const url = baseUrl + fileName;
                        const blob = await fetch(url).then(resp => resp.blob());

                        // Solo procesar PDFs para contrato y apud
                        const tipoDocumento = identificarTipoDocumento(fileName);
                        if ((tipoDocumento === 'contrato' || tipoDocumento === 'apud') && fileName.toLowerCase().endsWith('.pdf')) {
                            documentBlobs[tipoDocumento] = {
                                blob: blob,
                                name: fileName
                            };
                        }

                        return saveAs(blob, fileName);
                    });

                    await Promise.all(downloadPromises);

                    // Setear los archivos para el FormGastos2
                    if (documentBlobs.contrato) {
                        setContratoFile(documentBlobs.contrato);
                    }
                    if (documentBlobs.apud) {
                        setApudFile(documentBlobs.apud);
                    }
                    if (documentBlobs.reclamacion) {
                        setReclamacionFile(documentBlobs.reclamacion);
                    }

                    toast.success(t("¡Archivos descargados correctamente!"));
                    setStep1Loading(false);

                    if (numeroNegocioGastos !== '' && numeroNegocioGastos !== null && numeroNegocioGastos !== undefined && formType !== 'demanda') {
                        setStep(2);
                    }
                } catch (error) {
                    handleError(error, setStep1Loading);
                    console.log(error);
                    toast.error(t("Ha ocurrido un error inesperado"));
                    setStep1Loading(false);
                }
            }).catch((error) => {
                handleError(error, setStep1Loading);
                console.log(error);
                toast.error(t("Ha ocurrido un error inesperado"));
                setStep1Loading(false);
            });
        }
    }

    useEffect(() => {
        const totalGastos = (
            (Number(autoFill.gastos_notaria_gastos) || 0) * 0.5 +
            (Number(autoFill.gastos_notaria_gastos_adicional) || 0) * 0.5 +
            (Number(autoFill.gastos_registro_gastos) || 0) +
            (Number(autoFill.gastos_registro_gastos_adicional) || 0) +
            (Number(autoFill.gastos_gestoria_gastos) || 0) +
            (Number(autoFill.gastos_gestoria_gastos_adicional) || 0) +
            (Number(autoFill.gastos_tasacion_gastos) || 0) +
            (Number(autoFill.gastos_tasacion_gastos_adicional) || 0)
        ).toFixed(2); // Redondea a 2 decimales

        setAutoFill(prevState => ({ ...prevState, total_gastos: totalGastos }));
    }, [autoFill.gastos_notaria_gastos, autoFill.gastos_notaria_gastos_adicional,
    autoFill.gastos_registro_gastos, autoFill.gastos_registro_gastos_adicional,
    autoFill.gastos_gestoria_gastos, autoFill.gastos_gestoria_gastos_adicional,
    autoFill.gastos_tasacion_gastos, autoFill.gastos_tasacion_gastos_adicional]);

    const handleChangeFechaInicioPrestamo = (e) => {
        const inputValue = e.target.value;
        
        // Actualizar el estado siempre para que el input se actualice
        setAutoFill(prevState => ({ ...prevState, [e.target.name]: inputValue }));
        
        // Limpiar error anterior solo si hay contenido
        if (inputValue) {
            setFechaError('');
        }
        
        // Solo validar si la fecha está completa (formato YYYY-MM-DD del input date)
        if (inputValue && inputValue.length === 10 && inputValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const selectedDate = new Date(inputValue + 'T00:00:00'); // Añadir hora para evitar problemas de zona horaria
            const limitDate = new Date('2020-01-01T00:00:00');
            const apudCheck = new Date('2017-01-01T00:00:00');
            const prescripcionDate = new Date('1994-01-01T00:00:00'); // Cambiado a 1994 como solicitaste
            
            // Verificar que la fecha es válida
            if (isNaN(selectedDate.getTime())) {
                return; // Fecha inválida, no hacer nada
            }
            
            // Validar fecha de prescripción (antes de 1994)
            if (selectedDate < prescripcionDate) {
                setFechaError('La fecha es anterior a 1994. El caso ha prescrito y no es reclamable.');
                return;
            }
            
            if (selectedDate > limitDate) {
                setFechaError('La fecha no puede ser mayor que el 1 de enero de 2020');
                return;
            }
            
            if (selectedDate > apudCheck) {
                // Mostrar modal de confirmación en lugar de alert
                setPendingApudDate(inputValue);
                setShowApudModal(true);
                return; // No actualizar el estado hasta que se confirme
            }
            
            if (selectedDate < apudCheck) {
                setSendApud(true);
            }
        }
    };

    // Función para manejar el cambio en el checkbox de demanda de gastos
    const handleDemandaGastosChange = (e) => {
        setDocumentosValidados(false);
        setValidationResults(null);
    };

    const handleValidationComplete = (results) => {
        setValidationResults(results.validation_summary);

        // Combinar los datos extraídos con las correcciones
        const combinedData = {
            ...results.validation_summary,
            corrected_data: results.corrected_data
        };
        setExtractedData(combinedData);


        // Auto-rellenar el formulario con los datos validados y corregidos
        const autoFillData = {};

        // Datos del DNI
        if (combinedData.dni?.status === 'success') {
            autoFillData.dni_gastos = combinedData.dni.checks.dni.actual;
            autoFillData.nombre_y_apellidos_gastos = combinedData.dni.checks.nombre.actual;
        }

        // Datos de notaría
        if (combinedData.notary?.status === 'success' || combinedData.notary?.checks) {
            autoFillData.nprotocolo_gastos = combinedData.notary.checks.protocolo.actual;
            if (combinedData.notary.checks.total) {
                autoFillData.gastos_notaria_gastos = combinedData.notary.checks.total.actual;
                // Sumar notary_2 si existe el campo total.actual
                if (
                  (combinedData.notary_2?.status === 'success' || combinedData.notary_2?.checks) &&
                  combinedData.notary_2?.checks?.total?.actual
                ) {
                    autoFillData.gastos_notaria_gastos =
                      (Number(autoFillData.gastos_notaria_gastos) || 0) +
                      (Number(combinedData.notary_2.checks.total.actual) || 0);
                }
            }
        }

        // Datos de registro
        if (combinedData.registry?.status === 'success' || combinedData.registry?.checks) {
            if (combinedData.registry.checks.amount) {
                autoFillData.gastos_registro_gastos = combinedData.registry.checks.amount.actual;
            }
            // Sumar registry_2 si existe el campo amount.actual
            if (
              (combinedData.registry_2?.status === 'success' || combinedData.registry_2?.checks) &&
              combinedData.registry_2?.checks?.amount?.actual
            ) {
                autoFillData.gastos_registro_gastos = (Number(autoFillData.gastos_registro_gastos) || 0) + (Number(combinedData.registry_2.checks.amount.actual) || 0);
            }

            // Si hay un protocolo corregido en corrected_data, usarlo
            if (combinedData.corrected_data?.registry?.protocolo) {
                autoFillData.nprotocolo_gastos = combinedData.corrected_data.registry.protocolo;
            }
        }

        // Datos de tasación
        if (combinedData.appraisal?.status === 'success' || combinedData.appraisal?.checks) {
            if (combinedData.appraisal.checks.amount) {
                autoFillData.gastos_tasacion_gastos = combinedData.appraisal.checks.amount.actual;
            }
            // Sumar appraisal_2 si existe el campo amount.actual
            if (
              (combinedData.appraisal_2?.status === 'success' || combinedData.appraisal_2?.checks) &&
              combinedData.appraisal_2?.checks?.amount?.actual
            ) {
                autoFillData.gastos_tasacion_gastos = (Number(autoFillData.gastos_tasacion_gastos) || 0) + (Number(combinedData.appraisal_2.checks.amount.actual) || 0);
            }

            // Si hay un protocolo corregido en corrected_data, usarlo
            if (combinedData.corrected_data?.appraisal?.protocolo) {
                autoFillData.nprotocolo_gastos = combinedData.corrected_data.appraisal.protocolo;
            }
        }

        // Datos de gestoría
        if (combinedData.agency?.status === 'success' || combinedData.agency?.checks) {
            if (combinedData.agency.checks.amount) {
                autoFillData.gastos_gestoria_gastos = combinedData.agency.checks.amount.actual;
            }
            // Sumar agency_2 si existe el campo amount.actual
            if (
              (combinedData.agency_2?.status === 'success' || combinedData.agency_2?.checks) &&
              combinedData.agency_2?.checks?.amount?.actual
            ) {
                autoFillData.gastos_gestoria_gastos = (Number(autoFillData.gastos_gestoria_gastos) || 0) + (Number(combinedData.agency_2.checks.amount.actual) || 0);
            }

            // Si hay un protocolo corregido en corrected_data, usarlo
            if (combinedData.corrected_data?.agency?.protocolo) {
                autoFillData.nprotocolo_gastos = combinedData.corrected_data.agency.protocolo;
            }
        }

        setAutoFill(prev => ({
            ...prev,
            ...autoFillData
        }));
        setProcessValidationComplete(true);
    };

    // Añadir una nueva función para manejar la continuación después de la validación
    const handleContinueAfterValidation = () => {
        setDocumentosValidados(true);
    };

    // Funciones para manejar el modal de confirmación de APUD
    const handleApudConfirm = () => {
        setSendApud(true);
        if (pendingApudDate) {
            setAutoFill(prevState => ({ 
                ...prevState, 
                fecha_inicio_prestamo_gastos: pendingApudDate 
            }));
        }
        setPendingApudDate(null);
    };

    const handleApudCancel = () => {
        setSendApud(false);
        if (pendingApudDate) {
            setAutoFill(prevState => ({ 
                ...prevState, 
                fecha_inicio_prestamo_gastos: pendingApudDate 
            }));
        }
        setPendingApudDate(null);
    };

    const handleApudModalClose = () => {
        setShowApudModal(false);
        setPendingApudDate(null);
    };

    const handleDocumentosExtrajudicialProcessed = ({ apiResponse, binaryFiles, config }) => {
        const {
            documents,
            extracted_data,
        } = apiResponse;

        const { hasSecondPerson, hasAdditionalDocs } = config;

        if (hasSecondPerson) {
            setAutoFill(prev => ({
                ...prev,
                cantidad_personas: 2,
            }));
        }

        // Auto-rellenar cambiar a formato que se acepte en el input de tipo fecha
        const parsearFechaEspanol = (fechaStr) => {
            const [dia, mes, ano] = fechaStr.split('/');
            // Usamos UTC para evitar problemas con zona horaria
            return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        };

        // Extraer la fecha de inicio de prestamo SI EXISTE
        let fechaInicioPrestamoFormato = '';
        if (documents.notary?.extraido?.fecha_inicio_prestamo) {
            const fechaInicioPrestamo = parsearFechaEspanol(documents.notary.extraido.fecha_inicio_prestamo);
            fechaInicioPrestamoFormato = fechaInicioPrestamo; // Ya no necesitamos convertir a ISO
        }
        setAutoFill(prev => ({
            ...prev,
            // Datos personales desde extracted_data
            nombre_y_apellidos_gastos: `${extracted_data?.person1?.personal_info?.nombre} ${extracted_data?.person1?.personal_info?.apellidos}`,
            dni_gastos: extracted_data?.person1?.personal_info?.dni,
            direccion_gastos: extracted_data?.person1?.personal_info?.direccion,

            //Nombre notario
            notario_gastos: documents.notary?.extraido?.notario?.nombre || '',
            fecha_inicio_prestamo_gastos: fechaInicioPrestamoFormato,
            // Datos de los gastos desde extracted_data
            gastos_notaria_gastos: extracted_data.person1.notary_amount,
            gastos_registro_gastos: extracted_data.person1.registry_amount,
            gastos_tasacion_gastos: extracted_data.person1.appraisal_amount,
            gastos_gestoria_gastos: extracted_data.person1.agency_amount,

            // Protocolo desde documents.notary si está disponible
            nprotocolo_gastos: documents.notary?.extraido?.protocolo || ''
        }));

        if (hasAdditionalDocs) {
            setAutoFill(prev => ({
                ...prev,
                gastos_notaria_gastos_adicional: extracted_data.person2.notary_amount,
                gastos_registro_gastos_adicional: extracted_data.person2.registry_amount,
                gastos_tasacion_gastos_adicional: extracted_data.person2.appraisal_amount,
                gastos_gestoria_gastos_adicional: extracted_data.person2.agency_amount,
            }));
        }

        if (hasSecondPerson) {
            setAutoFill(prev => ({
                ...prev,
                nombre_y_apellidos2_gastos: `${extracted_data?.person2?.personal_info?.nombre} ${extracted_data?.person2?.personal_info?.apellidos}`,
                dni2_gastos: extracted_data?.person2?.personal_info?.dni,
            }));
        }

        // Guardar los archivos procesados
        if (binaryFiles.dni_front) {
            setDniFrontFile({
                file: binaryFiles.dni_front,
                name: binaryFiles.dni_front.name
            })
        }
        if (binaryFiles.dni_back) {
            setDniBackFile({
                file: binaryFiles.dni_back,
                name: binaryFiles.dni_back.name
            })
        }

        if (hasSecondPerson) {
            if (binaryFiles.dni_front_2) {
                setDniFrontFile2({
                    file: binaryFiles.dni_front_2,
                    name: binaryFiles.dni_front_2.name
                })
            }
            if (binaryFiles.dni_back_2) {
                setDniBackFile2({
                    file: binaryFiles.dni_back_2,
                    name: binaryFiles.dni_back_2.name
                })
            }
        }

        if (binaryFiles.notary) {
            setNotaryFile({
                file: binaryFiles.notary,
                name: binaryFiles.notary.name
            })
        }
        if (binaryFiles.registry) {
            setRegistryFile({
                file: binaryFiles.registry,
                name: binaryFiles.registry.name
            })
        }
        if (binaryFiles.agency) {
            setAgencyFile({
                file: binaryFiles.agency,
                name: binaryFiles.agency.name
            })
        }
        if (binaryFiles.appraisal) {
            setAppraisalFile({
                file: binaryFiles.appraisal,
                name: binaryFiles.appraisal.name
            })
        }

        if (hasAdditionalDocs) {
            if (binaryFiles.notary_2) {
                setNotaryFileAdditional({
                    file: binaryFiles.notary_2,
                    name: binaryFiles.notary_2.name
                })
            }
            if (binaryFiles.registry_2) {
                setRegistryFileAdditional({
                    file: binaryFiles.registry_2,
                    name: binaryFiles.registry_2.name
                })
            }

            if (binaryFiles.agency_2) {
                setAgencyFileAdditional({
                    file: binaryFiles.agency_2,
                    name: binaryFiles.agency_2.name
                })
            }

            if (binaryFiles.appraisal_2) {
                setAppraisalFileAdditional({
                    file: binaryFiles.appraisal_2,
                    name: binaryFiles.appraisal_2.name
                })
            }
        }

        // Extraer el código postal de la dirección si está disponible
        const codigoPostalMatch = documents.dni_back?.extraido?.codigo_postal
        if (codigoPostalMatch) {
            setAutoFill(prev => ({
                ...prev,
                codigo_postal_gastos: codigoPostalMatch
            }));
        }

        // Extraer la provincia de la dirección
        const direccionParts = extracted_data.person1.personal_info.direccion.split(' ');
        const provincia = direccionParts[direccionParts.length - 1];
        if (provincia) {
            setAutoFill(prev => ({
                ...prev,
                provincia_gastos: provincia,
                juzgado_especifico_gastos: `Juzgado especializado en ACCIONES INDIVIDUALES A LAS CONDICIONES GENERALES DE LA CONTRATACIÓN de la Provincia de ${provincia}, de acuerdo con el artículo 98.2 LOPJ y por ser el domicilio del demandante de acuerdo con el 52.2.14 de la Ley de Enjuiciamiento Civil`
            }));
        }

        // Marcar los documentos como validados
        setExtrajudicialFilesProcessed(true);
    };


    // Renderizado condicional basado en el tipo de formulario
    if (formType === 'reiteracion') {
        return (
            <>
                <QuickFormNavigation
                    formType={formType}
                    setFormType={setFormType}
                    onBack={() => setCurrentStep(1)}
                />
                <FormReiteracionGastos />
            </>
        );
    }

    // ADAPTAR el resto de renderizados condicionales:
    // Donde antes era 'demandaGastos', ahora es 'formType === "demanda"'
    // Donde antes era '!demandaGastos', ahora es 'formType === "extrajudicial"'

    if (formType === 'demanda' && !documentosValidados) {
        return (
            <div className="space-y-2">
                <QuickFormNavigation
                    formType={formType}
                    setFormType={setFormType}
                    onBack={() => setCurrentStep(1)}
                />
                <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4">
                    <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {t("🖋  Validación de documentos para ")}
                        <span className="underline decoration-primary-500">{t("Demanda de Gastos")}</span>
                    </h2>
                    <div className="flex flex-col md:flex-row gap-3">
                        <button
                            className="w-full md:w-auto flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700"
                            onClick={() => {
                                setDocumentosValidados(true);
                            }}
                        >
                            {t("Continuar sin validar")}
                        </button>
                    </div>
                </div>
                <div className="col-span-2 sm:col-span-2">
                    {/* Preguntar por el número de negocio */}
                    <label htmlFor="numero_negocio_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400 mb-2 mx-auto w-3/">
                        Buscar negocio
                    </label>
                    <div className="flex flex-col mb-10 w-full max-w-4xl mx-auto">
                        {/* Barra de búsqueda con efecto de elevación */}
                        <div className="flex mb-8 w-full">
                            <div className="relative w-full flex shadow-lg rounded-lg">
                                <input
                                    type="text"
                                    value={autoFill.numero_negocio_gastos}
                                    name="numero_negocio_gastos"
                                    id="numero_negocio_gastos"
                                    autoComplete="numero_negocio_gastos"
                                    className="w-full px-4 py-3 rounded-l-lg border-0 ring-1 ring-gray-200 focus:ring-2 focus:ring-primary-500 transition-all duration-200 dark:bg-gray-800 dark:ring-gray-700 dark:text-white"
                                    placeholder="Buscar un número de negocio..."
                                    onChange={(e) => handleInputChangeProtocol(e)}
                                />
                                <button
                                    type="button"
                                    disabled={step1Loading}
                                    className="px-6 rounded-r-lg bg-primary-600 hover:bg-primary-700 transition-colors duration-200 flex items-center justify-center gap-2 text-white font-medium dark:bg-blue-600 dark:hover:bg-blue-700"
                                    onClick={async () => {
                                        toast.loading('Buscando número de negocio...')
                                        const datos = await buscarNumeroNegocioBaserow(autoFill.numero_negocio_gastos)
                                        toast.dismiss()
                                        setNegocioData(datos)
                                        if (datos && datos.length > 0) {
                                            // Datos de la primera persona y datos generales
                                            const bancoNombre = datos[1][0]?.['Banco'];
                                            setAutoFill({
                                                ...autoFill,
                                                banco_gastos: bancoNombre,
                                                codigo_postal_gastos: datos[0]?.['Codigo Postal'],
                                                dni_gastos: datos[0]?.['DNI'],
                                                telefono_gastos: datos[0]?.['Telefono'],
                                                direccion_gastos: datos[0]?.['Direccion'],
                                                email_gastos: datos[0]?.['Email'],
                                                provincia_gastos: datos[0]?.['Provincia'],
                                                fecha_inicio_prestamo_gastos: datos[1][0]?.['Fecha Inicio Prestamo'],
                                                fecha_extrajudicial_gastos: datos[1][0]?.['Fecha Reclamacion Extrajudicial'],
                                                nombre_y_apellidos_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                notario_gastos: datos[1][0]?.['Notario'],
                                                gastos_gestoria_gastos: datos[1][0]?.['Gastos Gestoria'],
                                                gastos_notaria_gastos: datos[1][0]?.['Gastos Notaria'],
                                                gastos_registro_gastos: datos[1][0]?.['Gastos Registro'],
                                                gastos_tasacion_gastos: datos[1][0]?.['Gastos Tasacion'],
                                                numero_negocio_gastos: datos[1][0]?.['Numero Negocio'],
                                                gastos_gestoria_gastos_adicional: datos[1][0]?.['Gastos Gestoria Adicional'],
                                                gastos_notaria_gastos_adicional: datos[1][0]?.['Gastos Notaria Adicional'],
                                                gastos_registro_gastos_adicional: datos[1][0]?.['Gastos Registro Adicional'],
                                                gastos_tasacion_gastos_adicional: datos[1][0]?.['Gastos Tasacion Adicional'],
                                                // Datos de la segunda persona si existe
                                                dni2_gastos: datos[2]?.['DNI'] || '',
                                                telefono2_gastos: datos[2]?.['Telefono'] || '',
                                                nombre_y_apellidos2_gastos: datos[2]?.['Nombre Y Apellidos'] || '',
                                            });

                                            // Actualizar banco y bancos absorbidos
                                            updateBankAndAbsorbedBanks(bancoNombre);

                                            // Si hay una segunda persona, actualizar la cantidad de personas
                                            if (datos[2]) {
                                                setCantidadPersonasGE(2);
                                            }

                                            handleChangeFechaInicioPrestamo({
                                                target: {
                                                    name: 'fecha_inicio_prestamo_gastos',
                                                    value: datos[1][0]?.['Fecha Inicio Prestamo']
                                                }
                                            });
                                        }
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                    </svg>
                                    Buscar
                                </button>
                            </div>
                        </div>

                        {negocioData && (
                            <div className="space-y-6 animate-fadeIn">
                                {/* Card de datos personales */}
                                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                                    <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">
                                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                            Datos Personales
                                        </h3>
                                    </div>
                                    <div className="p-6 overflow-x-auto">
                                        <table className="w-full">
                                            <thead>
                                                <tr className="border-b border-gray-200 dark:border-gray-700">
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("DNI")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Nombre cliente")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Dirección")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Código Postal")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Provincia")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Teléfono")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="border-b border-gray-200 dark:border-gray-700">
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[0]['DNI']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[0]['Nombre Y Apellidos']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[0]['Direccion']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[0]['Codigo Postal']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[0]['Provincia']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[0]['Telefono']}</td>
                                                </tr>
                                                {negocioData[2] && (
                                                    <tr>
                                                        <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[2]['DNI']}</td>
                                                        <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[2]['Nombre Y Apellidos']}</td>
                                                        <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[2]['Direccion']}</td>
                                                        <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[2]['Codigo Postal']}</td>
                                                        <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[2]['Provincia']}</td>
                                                        <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[2]['Telefono']}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Card de datos de la demanda */}
                                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                                    <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">
                                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                            Datos de la reclamación extrajudicial
                                        </h3>
                                    </div>
                                    <div className="p-6 overflow-x-auto">
                                        <table className="w-full">
                                            <thead>
                                                <tr className="border-b border-gray-200 dark:border-gray-700">
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Número Negocio")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Número de Protocolo")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Banco")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Fecha Inicio Préstamo")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Fecha Reclamación")}</th>
                                                    <th className="py-3 px-4 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">{t("Notario")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="border-b border-gray-200 dark:border-gray-700">
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[1][0]['Numero Negocio']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[1][0]['Numero Protocolo']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[1][0]['Banco']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[1][0]['Fecha Inicio Prestamo']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[1][0]['Fecha Reclamacion Extrajudicial']}</td>
                                                    <td className="py-4 px-4 text-sm text-gray-700 dark:text-gray-300">{negocioData[1][0]['Notario']}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* Gastos en cards */}
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                                            {/* Gastos Gestoría */}
                                            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Gestoría</p>
                                                <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                    {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Gestoria'] || 0)}
                                                </p>
                                                {negocioData[1][0]['Documento Gestoría']?.length > 0 && (
                                                    <button
                                                        onClick={() => window.open(negocioData[1][0]['Documento Gestoría'][0].url, '_blank')}
                                                        className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                    >
                                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>
                                                        Ver documento
                                                    </button>
                                                )}
                                            </div>

                                            {/* Gastos Gestoría Adicional */}
                                            {(negocioData[1][0]['Gastos Gestoria Adicional'] || 0) != 0 && (
                                                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Gestoría Adicional</p>
                                                    <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                        {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Gestoria Adicional'] || 0)}
                                                    </p>
                                                    {negocioData[1][0]['Documento Gestoría Adicional']?.length > 0 && (
                                                        <button
                                                            onClick={() => window.open(negocioData[1][0]['Documento Gestoría Adicional'][0].url, '_blank')}
                                                            className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                            </svg>
                                                            Ver documento
                                                        </button>
                                                    )}
                                                </div>
                                            )}

                                            {/* Gastos Notaría */}
                                            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Notaría</p>
                                                <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                    {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Notaria'] || 0)}
                                                </p>
                                                {negocioData[1][0]['Documento Notaría']?.length > 0 && (
                                                    <button
                                                        onClick={() => window.open(negocioData[1][0]['Documento Notaría'][0].url, '_blank')}
                                                        className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                    >
                                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>
                                                        Ver documento
                                                    </button>
                                                )}
                                            </div>

                                            {/* Gastos Notaría Adicional */}
                                            {(negocioData[1][0]['Gastos Notaria Adicional'] || 0) != 0 && (
                                                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Notaría Adicional</p>
                                                    <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                        {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Notaria Adicional'] || 0)}
                                                    </p>
                                                    {negocioData[1][0]['Documento Notaría Adicional']?.length > 0 && (
                                                        <button
                                                            onClick={() => window.open(negocioData[1][0]['Documento Notaría Adicional'][0].url, '_blank')}
                                                            className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                            </svg>
                                                            Ver documento
                                                        </button>
                                                    )}
                                                </div>
                                            )}

                                            {/* Gastos Registro */}
                                            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Registro</p>
                                                <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                    {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Registro'] || 0)}
                                                </p>
                                                {negocioData[1][0]['Documento Registro']?.length > 0 && (
                                                    <button
                                                        onClick={() => window.open(negocioData[1][0]['Documento Registro'][0].url, '_blank')}
                                                        className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                    >
                                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>
                                                        Ver documento
                                                    </button>
                                                )}
                                            </div>

                                            {/* Gastos Registro Adicional */}
                                            {(negocioData[1][0]['Gastos Registro Adicional'] || 0) != 0 && (
                                                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Registro Adicional</p>
                                                    <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                        {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Registro Adicional'] || 0)}
                                                    </p>
                                                    {negocioData[1][0]['Documento Registro Adicional']?.length > 0 && (
                                                        <button
                                                            onClick={() => window.open(negocioData[1][0]['Documento Registro Adicional'][0].url, '_blank')}
                                                            className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                            </svg>
                                                            Ver documento
                                                        </button>
                                                    )}
                                                </div>
                                            )}

                                            {/* Gastos Tasación */}
                                            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Tasación</p>
                                                <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                    {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Tasacion'] || 0)}
                                                </p>
                                                {negocioData[1][0]['Documento Tasación']?.length > 0 && (
                                                    <button
                                                        onClick={() => window.open(negocioData[1][0]['Documento Tasación'][0].url, '_blank')}
                                                        className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                    >
                                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>
                                                        Ver documento
                                                    </button>
                                                )}
                                            </div>

                                            {/* Gastos Tasación Adicional */}
                                            {(negocioData[1][0]['Gastos Tasacion Adicional'] || 0) != 0 && (
                                                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Gastos Tasación Adicional</p>
                                                    <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">
                                                        {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(negocioData[1][0]['Gastos Tasacion Adicional'] || 0)}
                                                    </p>
                                                    {negocioData[1][0]['Documento Tasación Adicional']?.length > 0 && (
                                                        <button
                                                            onClick={() => window.open(negocioData[1][0]['Documento Tasación Adicional'][0].url, '_blank')}
                                                            className="mt-2 flex items-center text-sm text-primary-600 hover:text-primary-700"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                            </svg>
                                                            Ver documento
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <DocumentUploadForm
                        autoFill={autoFill}
                        setAutoFill={setAutoFill}
                        negocioData={negocioData}
                        onValidationComplete={handleValidationComplete}
                        initialDocuments={
                            negocioData && negocioData[1] && negocioData[1][0] ? {
                                'Documento Notaría': negocioData[1][0]['Documento Notaría'],
                                'Documento Registro': negocioData[1][0]['Documento Registro'],
                                'Documento Gestoría': negocioData[1][0]['Documento Gestoría'],
                                'Documento Tasación': negocioData[1][0]['Documento Tasación'],
                                'Documento DNI': negocioData[1][0]['Documento DNI Front'],
                                'Documento DNI Adicional': negocioData[1][0]['Documento DNI Front Adicional'],
                                'Documento Notaría Adicional': negocioData[1][0]['Documento Notaría Adicional'],
                                'Documento Registro Adicional': negocioData[1][0]['Documento Registro Adicional'],
                                'Documento Tasación Adicional': negocioData[1][0]['Documento Tasación Adicional'],
                                'Documento Gestoría Adicional': negocioData[1][0]['Documento Gestoría Adicional'],
                            } : {
                                'Documento Notaría': [],
                                'Documento Registro': [],
                                'Documento Gestoría': [],
                                'Documento Tasación': [],
                                'Documento DNI': [],
                                'Documento DNI Adicional': [],
                                'Documento Notaría Adicional': [],
                                'Documento Registro Adicional': [],
                                'Documento Tasación Adicional': [],
                                'Documento Gestoría Adicional': [],
                            }
                        }
                    />
                    {formType === 'demanda' && processValidationComplete && (
                        <div className="flex justify-end my-4">
                            <button
                                className="w-full md:w-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-4 focus:ring-primary-300"
                                onClick={handleContinueAfterValidation}
                            >
                                {t("Continuar")}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    if (formType === 'extrajudicial' && !extrajudicialFilesProcessed) {
        return (
            <>
                <QuickFormNavigation
                    formType={formType}
                    setFormType={setFormType}
                    onBack={() => setCurrentStep(1)}
                />
                <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4">
                    <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {t("🖋  Rellenando documentos de ")}
                        <span className="underline decoration-primary-500">{t("Reclamación Extrajudicial")}</span>
                    </h2>
                    <div className="flex flex-col md:flex-row gap-3">
                        <button
                            className="w-full md:w-auto flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700"
                            onClick={() => {
                                setExtrajudicialFilesProcessed(true);
                            }}
                        >
                            {t("Continuar sin validar")}
                        </button>
                    </div>
                </div>

                <DocumentosExtrajudicialForm
                    onProcessComplete={handleDocumentosExtrajudicialProcessed}
                />
            </>
        )
    }

    return (
        <>
            {step === 1 && (
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4 mb-3">
                        <h2 className="col-span-2 sm:col-span-2 mt-4 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                            {!formType ?
                                <>
                                    {t("🖋  Rellenando documento de ")}
                                    <span className=" underline decoration-primary-500">{t("Gastos Extrajudiciales")}</span>
                                </>
                                :
                                <>
                                    {t("🖋  Rellenando documento de ")}
                                    <span className=" underline decoration-primary-500">{t("Demanda Gastos")}</span>
                                </>
                            }
                        </h2>
                        <div className="w-full md:w-auto flex flex-col md:flex-row items-stretch md:items-center justify-end  flex-shrink-0">
                            <button className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-4 focus:ring-primary-300" onClick={(e) => { e.preventDefault(); setExtrajudicialFilesProcessed(false); setDocumentosValidados(false); }}>
                                {t("Volver atrás")}
                            </button>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                        {formType === 'demanda' && (
                            <div className="col-span-2 sm:col-span-2">
                                <label className="flex items-center cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-400" htmlFor="solo_demanda_gastos">
                                    <span className="mr-3">{t("¿Generar sólo el archivo de demanda?")}</span>
                                    <div className="relative">
                                        <input disabled={step1Loading} defaultChecked={formType === 'demanda'} type="checkbox" id="solo_demanda_gastos" name="solo_demanda_gastos" autoComplete="solo_demanda_gastos" className="sr-only peer" onChange={(e) => setOneFile(e.target.checked)} />
                                        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:bg-blue-600"></div>
                                        <div className="absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition-all duration-200 peer-checked:left-6"></div>
                                    </div>
                                </label>
                            </div>
                        )}
                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="cantidad_personas_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Cantidad de personas")} *</label>
                            <select disabled={step1Loading} id="cantidad_personas_gastos" name="cantidad_personas_gastos" autoComplete="cantidad_personas_gastos" className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-600 focus:border-primary-600 sm:text-sm dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required onChange={(e) => { setCantidadPersonasGE(e.target.value) }}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                            </select>
                        </div>
                        {formType === 'demanda' ? (
                            <>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="numero_negocio_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Número de negocio")} </label>
                                    <div className="mt-1 flex">
                                        <input
                                            disabled={step1Loading}
                                            type="text"
                                            value={autoFill.numero_negocio_gastos}
                                            name="numero_negocio_gastos"
                                            id="numero_negocio_gastos"
                                            autoComplete="numero_negocio_gastos"
                                            className="focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-l-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="Buscar un número de negocio..."
                                            onChange={(e) => handleInputChangeProtocol(e)}
                                        />
                                        <button
                                            type="button"
                                            disabled={step1Loading}
                                            className="inline-flex items-center px-3 py-2 mt-0 border border-l-0 border-gray-300 shadow-sm text-sm font-medium rounded-r-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-500"
                                            onClick={async () => {
                                                const datos = await buscarNumeroNegocioBaserow(autoFill.numero_negocio_gastos)
                                                let hubspotData = {};
                                                try {
                                                    const webhookN8NHubspot = "https://n8n-615087458109.europe-southwest1.run.app/webhook/5b6dba31-3395-4b45-b8b0-c961f4f32026"

                                                    const response = await axios.get(webhookN8NHubspot, { params: { numero_negocio: autoFill.numero_negocio_gastos } })
                                                    //Comprobar si existe la fecha del envío al banco
                                                    if (response.data[1]) {
                                                        // Obtener la fecha de envío al banco
                                                        let fechaEnvioBanco = response.data[1]["properties.fecha_del_envio_al_banco.value"] || '';

                                                        // Convertir la fecha del formato MM/DD/YYYY a YYYY-MM-DD para el input type="date"
                                                        if (fechaEnvioBanco) {
                                                            try {
                                                                // Separar la fecha por "/"
                                                                const partes = fechaEnvioBanco.split('/');
                                                                if (partes.length === 3) {
                                                                    // El formato es MM/DD/YYYY (no DD/MM/YYYY)
                                                                    const [mes, dia, anio] = partes;

                                                                    // Asegurarse de que mes y día tengan dos dígitos
                                                                    const mesFormateado = mes.padStart(2, '0');
                                                                    const diaFormateado = dia.padStart(2, '0');

                                                                    // Formato YYYY-MM-DD para el input type="date"
                                                                    fechaEnvioBanco = `${anio}-${mesFormateado}-${diaFormateado}`;

                                                                    // Validar si la fecha es de 11 meses o más, y 
                                                                    const fechaEnvio = new Date(fechaEnvioBanco);
                                                                    const fechaActual = new Date();
                                                                    const diferenciaMeses = (fechaActual.getFullYear() - fechaEnvio.getFullYear()) * 12 + (fechaActual.getMonth() - fechaEnvio.getMonth());
                                                                    
                                                                    //La fecha que se vea en el toast tiene que ser formato DD/MM/YYYY
                                                                    const fechaEnvioBancoFormato = new Date(fechaEnvioBanco).toLocaleDateString('es-ES');

                                                                    if (diferenciaMeses >= 1) {
                                                                        toast(`ATENCIÓN: La fecha del envío al banco (${fechaEnvioBancoFormato}) es de ${diferenciaMeses} meses. Revisar cuidadosamente el caso.`, {
                                                                            icon: '⚠️',
                                                                            duration: 8000,
                                                                            style: {
                                                                                background: '#FEF3C7',
                                                                                color: '#92400E',
                                                                                border: '2px solid #F59E0B',
                                                                                fontWeight: 'bold'
                                                                            }
                                                                        });
                                                                    }

                                                                    // Actualizar directamente el autoFill completo en lugar de mezclarlo con hubspotData
                                                                    setAutoFill(prevState => {
                                                                        const newState = {
                                                                            ...prevState,
                                                                            fecha_extrajudicial_gastos: fechaEnvioBanco
                                                                        };
                                                                        return newState;
                                                                    });

                                                                    // También forzar la actualización del DOM después de un pequeño delay
                                                                    setTimeout(() => {
                                                                        const fechaInput = document.getElementById('fecha_extrajudicial_gastos');
                                                                        if (fechaInput) {
                                                                            fechaInput.value = fechaEnvioBanco;

                                                                            // Disparar un evento para notificar el cambio
                                                                            const inputEvent = new Event('input', { bubbles: true });
                                                                            fechaInput.dispatchEvent(inputEvent);

                                                                            const changeEvent = new Event('change', { bubbles: true });
                                                                            fechaInput.dispatchEvent(changeEvent);
                                                                        } else {
                                                                            console.log('Input no encontrado');
                                                                        }
                                                                    }, 200);
                                                                }
                                                            } catch (error) {
                                                                console.error('Error al formatear la fecha:', error);
                                                            }
                                                        }

                                                        hubspotData = {
                                                            fecha_extrajudicial_gastos: fechaEnvioBanco,
                                                        }
                                                    }

                                                    // Actualizar teléfono y email si están disponibles
                                                    if (response.data[0]) {
                                                        hubspotData = {
                                                            ...hubspotData,
                                                            telefono_gastos: response.data[0]["properties.phone.value"] || '',
                                                            email_gastos: response.data[0]["properties.email.value"] || ''
                                                        }
                                                    }

                                                    // Actualizar banco si está disponible
                                                    if (response.data[1] && response.data[1]["properties.banco_origen.value"]) {
                                                        hubspotData = {
                                                            ...hubspotData,
                                                            banco_gastos: response.data[1]["properties.banco_origen.value"] || ''
                                                        }
                                                    }

                                                    toast.success(t("Datos de Hubspot introducidos"))
                                                } catch (error) {
                                                    console.error('Error al enviar el número de negocio a Hubspot:', error)
                                                }

                                                // Actualizar con datos de Hubspot aunque no haya datos de Baserow
                                                setAutoFill(prev => ({
                                                    ...prev,
                                                    ...hubspotData
                                                }));

                                                setNegocioData(datos)
                                                if (datos && datos.length > 0) {
                                                    // Datos de la primera persona y datos generales
                                                    const bancoNombre = datos[1][0]?.['Banco'];
                                                    setAutoFill({
                                                        ...autoFill,
                                                        banco_gastos: bancoNombre,
                                                        codigo_postal_gastos: datos[0]?.['Codigo Postal'],
                                                        dni_gastos: datos[0]?.['DNI'],
                                                        telefono_gastos: datos[0]?.['Telefono'],
                                                        direccion_gastos: datos[0]?.['Direccion'],
                                                        email_gastos: datos[0]?.['Email'],
                                                        provincia_gastos: datos[0]?.['Provincia'],
                                                        fecha_inicio_prestamo_gastos: datos[1][0]?.['Fecha Inicio Prestamo'],
                                                        nombre_y_apellidos_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                        notario_gastos: datos[1][0]?.['Notario'],
                                                        gastos_gestoria_gastos: datos[1][0]?.['Gastos Gestoria'],
                                                        gastos_notaria_gastos: datos[1][0]?.['Gastos Notaria'],
                                                        gastos_registro_gastos: datos[1][0]?.['Gastos Registro'],
                                                        gastos_tasacion_gastos: datos[1][0]?.['Gastos Tasacion'],
                                                        gastos_gestoria_gastos_adicional: datos[1][0]?.['Gastos Gestoria Adicional'],
                                                        gastos_notaria_gastos_adicional: datos[1][0]?.['Gastos Notaria Adicional'],
                                                        gastos_registro_gastos_adicional: datos[1][0]?.['Gastos Registro Adicional'],
                                                        gastos_tasacion_gastos_adicional: datos[1][0]?.['Gastos Tasacion Adicional'],
                                                        numero_negocio_gastos: datos[1][0]?.['Numero Negocio'],
                                                        // Datos de la segunda persona si existe
                                                        dni2_gastos: datos[2]?.['DNI'] || '',
                                                        telefono2_gastos: datos[2]?.['Telefono'] || '',
                                                        nombre_y_apellidos2_gastos: datos[2]?.['Nombre Y Apellidos'] || '',
                                                    });

                                                    // Actualizar banco y bancos absorbidos
                                                    updateBankAndAbsorbedBanks(bancoNombre);

                                                    // Si hay una segunda persona, actualizar la cantidad de personas
                                                    if (datos[2]) {
                                                        setCantidadPersonasGE(2);
                                                    }

                                                    handleChangeFechaInicioPrestamo({
                                                        target: {
                                                            name: 'fecha_inicio_prestamo_gastos',
                                                            value: datos[1][0]?.['Fecha Inicio Prestamo']
                                                        }
                                                    });
                                                }
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="dni_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">DNI *</label>
                                    <div className="mt-1 flex">
                                        <input
                                            disabled={step1Loading}
                                            type="text"
                                            value={autoFill.dni_gastos}
                                            name="dni_gastos"
                                            id="dni_gastos"
                                            autoComplete="dni_gastos"
                                            className="focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-l-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="DNI"
                                            required
                                            onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        />
                                        <button
                                            type="button"
                                            disabled={step1Loading}
                                            className="inline-flex items-center px-3 py-2 mt-0 border border-l-0 border-gray-300 shadow-sm text-sm font-medium rounded-r-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-500"
                                            onClick={async () => {
                                                if (validacionDNIoNIF(autoFill.dni_gastos)) {
                                                    const datos = await buscarDNIEnBaserow(autoFill.dni_gastos, 'Gastos');
                                                    if (datos && datos.length > 0) {
                                                        if (datos[1].length == 1 || datos[1].length == 0) {
                                                            // Rellenar el formulario con los datos
                                                            const bancoNombre = datos[1]?.['Banco'];
                                                            setAutoFill({
                                                                ...autoFill,
                                                                banco_gastos: bancoNombre,
                                                                codigo_postal_gastos: datos[0]?.['Codigo Postal'],
                                                                dni_gastos: datos[0]?.['DNI'],
                                                                telefono_gastos: datos[0]?.['Telefono'],
                                                                direccion_gastos: datos[0]?.['Direccion'],
                                                                email_gastos: datos[0]?.['Email'],
                                                                provincia_gastos: datos[0]?.['Provincia'],
                                                                fecha_inicio_prestamo_gastos: datos[1][0]?.['Fecha Inicio Prestamo'],
                                                                fecha_extrajudicial_gastos: datos[1][0]?.['Fecha Reclamacion Extrajudicial'],
                                                                nombre_y_apellidos_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                                notario_gastos: datos[1][0]?.['Notario'],
                                                                gastos_gestoria_gastos: datos[1][0]?.['Gastos Gestoria'],
                                                                gastos_notaria_gastos: datos[1][0]?.['Gastos Notaria'],
                                                                gastos_registro_gastos: datos[1][0]?.['Gastos Registro'],
                                                                gastos_tasacion_gastos: datos[1][0]?.['Gastos Tasacion'],
                                                                numero_negocio_gastos: datos[1][0]?.['Numero Negocio'],
                                                            });

                                                            // Actualizar banco y bancos absorbidos
                                                            updateBankAndAbsorbedBanks(bancoNombre);

                                                            handleChangeFechaInicioPrestamo({ target: { name: 'fecha_inicio_prestamo_gastos', value: datos[1]?.['Fecha Inicio Prestamo'] } });
                                                        }
                                                        if (datos[1].length > 1) {
                                                            setOpen(true);
                                                            //Juntar los datos de datos[0] con cada uno de los datos de datos[1]
                                                            let datosCompletos = []
                                                            datos[1].forEach((element) => {
                                                                let { Email, ...rest } = element; // Excluir Email de datos[1] (provisional) de cada elemento
                                                                datosCompletos.push({ ...datos[0], ...rest }) // Combinar datos[0] con el resto de cada elemento
                                                            })
                                                            setData(datosCompletos);
                                                        }
                                                    }
                                                } else {
                                                    toast.error(t("El DNI introducido no es válido"));
                                                }
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-span-2 sm:col-span-2" style={{ display: cantidadPersonasGE == 2 ? "block" : "none" }}>
                                    <label htmlFor="dni2_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">DNI 2 *</label>
                                    <input
                                        disabled={step1Loading}
                                        type="text"
                                        value={autoFill.dni2_gastos}
                                        name="dni2_gastos"
                                        id="dni2_gastos"
                                        autoComplete="dni2_gastos"
                                        className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder="DNI 2"
                                        onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        onBlur={async (e) => {
                                            if (validacionDNIoNIF(e.target.value)) {
                                                const datos = await buscarDNIEnBaserow(e.target.value, 'Gastos');

                                                if (datos && datos.length > 0) {

                                                    if (datos[1].length == 1 || datos[1].length == 0) {
                                                        // Rellenar el formulario con los datos
                                                        setAutoFill({
                                                            ...autoFill,
                                                            dni2_gastos: datos[0]?.['DNI'],
                                                            telefono2_gastos: datos[0]?.['Telefono'],
                                                            nombre_y_apellidos2_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                        });
                                                    }
                                                    if (datos[1].length > 1) {
                                                        setOpen(true);
                                                        //Juntar los datos de datos[0] con cada uno de los datos de datos[1]
                                                        let datosCompletos = []
                                                        datos[1].forEach((element) => {
                                                            let { Email, ...rest } = element; // Excluir Email de cada elemento
                                                            datosCompletos.push({ ...datos[0], ...rest }) // Combinar datos[0] con el resto de cada elemento
                                                        })
                                                        setData(datosCompletos);
                                                    }
                                                }
                                            } else {
                                                toast.error(t("El DNI introducido no es válido"));
                                            }
                                        }}
                                    >
                                    </input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="nombre_y_apellidos_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Nombre y apellidos")} *</label>
                                    <input disabled={step1Loading} value={autoFill.nombre_y_apellidos_gastos} type="text" name="nombre_y_apellidos_gastos" id="nombre_y_apellidos_gastos" autoComplete="nombre_y_apellidos_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Nombre y Apellidos")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2" style={{ display: cantidadPersonasGE == 2 ? "block" : "none" }}>
                                    <label htmlFor="nombre_y_apellidos2_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Nombre y apellidos 2")}</label>
                                    <input disabled={step1Loading} value={autoFill.nombre_y_apellidos2_gastos} type="text" name="nombre_y_apellidos2_gastos" id="nombre_y_apellidos2_gastos" autoComplete="nombre_y_apellidos2_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} placeholder={t("Nombre y Apellidos 2")}></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="direccion_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Dirección")} *</label>
                                    <input disabled={step1Loading} ref={inputRef} value={autoFill.direccion_gastos} type="text" name="direccion_gastos" id="direccion_gastos" autoComplete="direccion_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Dirección")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="codigo_postal_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Código Postal")} *</label>
                                    <input disabled={step1Loading} ref={postalCodeRef} value={autoFill.codigo_postal_gastos} type="text" name="codigo_postal_gastos" id="codigo_postal_gastos" autoComplete="codigo_postal_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} placeholder={t("46011")} required></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="provincia_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Provincia")} *</label>
                                    <input
                                        disabled={step1Loading}
                                        ref={provinciaRef}
                                        value={autoFill.provincia_gastos}
                                        type="text"
                                        name="provincia_gastos"
                                        id="provincia_gastos"
                                        autoComplete="provincia_gastos"
                                        className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        onChange={handleProvinceChange} // Agregar el manejador de cambio aquí
                                        placeholder={t("Valencia")}
                                        required
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="numero_negocio_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Número de negocio")} </label>
                                    <div className="relative w-full flex rounded-lg">
                                        <input
                                            disabled={step1Loading}
                                            type="text"
                                            value={autoFill.numero_negocio_gastos}
                                            name="numero_negocio_gastos"
                                            id="numero_negocio_gastos"
                                            autoComplete="numero_negocio_gastos"
                                            className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-l-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="Buscar un número de negocio..."
                                            onChange={(e) => handleInputChangeProtocol(e)}
                                        />
                                        <button
                                            type="button"
                                            disabled={step1Loading}
                                            className="inline-flex items-center px-3 py-2 mt-1 border border-l-0 border-gray-300 shadow-sm text-sm font-medium rounded-r-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-500"
                                            onClick={async () => {
                                                const datos = await buscarNumeroNegocioBaserow(autoFill.numero_negocio_gastos)
                                                let hubspotData = {};
                                                try {
                                                    const webhookN8NHubspot = "https://n8n-615087458109.europe-southwest1.run.app/webhook/5b6dba31-3395-4b45-b8b0-c961f4f32026"
                                                    const response = await axios.get(webhookN8NHubspot, { params: { numero_negocio: autoFill.numero_negocio_gastos } })
                                                    if (response.data[0] && response.data[1]) {
                                                        hubspotData = {
                                                            telefono_gastos: response.data[0]["properties.phone.value"] || '',
                                                            email_gastos: response.data[0]["properties.email.value"] || '',
                                                            banco_gastos: response.data[1]["properties.banco_origen.value"] || ''
                                                        }
                                                    } else {
                                                        hubspotData = {
                                                            telefono_gastos: response.data[0]["properties.phone.value"] || '',
                                                            email_gastos: response.data[0]["properties.email.value"] || '',
                                                        }
                                                    }
                                                    toast.success(t("Datos de Hubspot introducidos"))
                                                } catch (error) {
                                                    console.error('Error al enviar el número de negocio a Hubspot:', error)
                                                }

                                                // Actualizar con datos de Hubspot aunque no haya datos de Baserow
                                                setAutoFill(prev => ({
                                                    ...prev,
                                                    ...hubspotData
                                                }));

                                                setNegocioData(datos)
                                                if (datos && datos.length > 0) {
                                                    const bancoNombre = datos[1][0]?.['Banco'] || hubspotData.banco_gastos;
                                                    setAutoFill(prev => ({
                                                        ...prev,
                                                        // Datos de Hubspot (por si acaso, para mantener prioridad)
                                                        ...hubspotData,
                                                        // Datos de Baserow
                                                        banco_gastos: bancoNombre,
                                                        codigo_postal_gastos: datos[0]?.['Codigo Postal'],
                                                        dni_gastos: datos[0]?.['DNI'],
                                                        telefono_gastos: hubspotData.telefono_gastos || datos[0]?.['Telefono'],
                                                        direccion_gastos: datos[0]?.['Direccion'],
                                                        email_gastos: hubspotData.email_gastos || datos[0]?.['Email'],
                                                        provincia_gastos: datos[0]?.['Provincia'],
                                                        fecha_inicio_prestamo_gastos: datos[1][0]?.['Fecha Inicio Prestamo'],
                                                        fecha_extrajudicial_gastos: datos[1][0]?.['Fecha Reclamacion Extrajudicial'],
                                                        nombre_y_apellidos_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                        notario_gastos: datos[1][0]?.['Notario'],
                                                        gastos_gestoria_gastos: datos[1][0]?.['Gastos Gestoria'],
                                                        gastos_notaria_gastos: datos[1][0]?.['Gastos Notaria'],
                                                        gastos_registro_gastos: datos[1][0]?.['Gastos Registro'],
                                                        gastos_tasacion_gastos: datos[1][0]?.['Gastos Tasacion'],
                                                        numero_negocio_gastos: datos[1][0]?.['Numero Negocio'],
                                                    }));

                                                    // Actualizar banco y bancos absorbidos
                                                    updateBankAndAbsorbedBanks(bancoNombre);

                                                    // Datos de la segunda persona si existe COMPROBAR SI EXITEN SI NO EXISTEN NI SE METEN YA QUE PODRIA SOBRESCRIBIR LOS QUE YA ESTAN PRESENTES EN EL FORMULARIO
                                                    if (datos[2]) {
                                                        setCantidadPersonasGE(2);

                                                        setAutoFill(prev => ({
                                                            ...prev,
                                                            dni2_gastos: datos[2]?.['DNI'],
                                                            telefono2_gastos: datos[2]?.['Telefono'],
                                                            nombre_y_apellidos2_gastos: datos[2]?.['Nombre Y Apellidos'],
                                                        }));
                                                    }

                                                    handleChangeFechaInicioPrestamo({
                                                        target: {
                                                            name: 'fecha_inicio_prestamo_gastos',
                                                            value: datos[1][0]?.['Fecha Inicio Prestamo']
                                                        }
                                                    });
                                                }
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                            </svg>

                                        </button>
                                    </div>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="dni_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">DNI *</label>
                                    <div className="mt-1 flex">
                                        <input
                                            disabled={step1Loading}
                                            type="text"
                                            value={autoFill.dni_gastos}
                                            name="dni_gastos"
                                            id="dni_gastos"
                                            autoComplete="dni_gastos"
                                            className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-l-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="DNI"
                                            required
                                            onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        />
                                        <button
                                            type="button"
                                            disabled={step1Loading}
                                            className="inline-flex items-center px-3 py-2 mt-1 border border-l-0 border-gray-300 shadow-sm text-sm font-medium rounded-r-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-500"
                                            onClick={async () => {
                                                if (validacionDNIoNIF(autoFill.dni_gastos)) {
                                                    const datos = await buscarDNIEnBaserow(autoFill.dni_gastos, 'Gastos');
                                                    if (datos && datos.length > 0) {
                                                        if (datos[1].length == 1 || datos[1].length == 0) {
                                                            // Rellenar el formulario con los datos
                                                            const bancoNombre = datos[1]?.['Banco'];
                                                            setAutoFill({
                                                                ...autoFill,
                                                                banco_gastos: bancoNombre,
                                                                codigo_postal_gastos: datos[0]?.['Codigo Postal'],
                                                                dni_gastos: datos[0]?.['DNI'],
                                                                telefono_gastos: datos[0]?.['Telefono'],
                                                                direccion_gastos: datos[0]?.['Direccion'],
                                                                email_gastos: datos[0]?.['Email'],
                                                                provincia_gastos: datos[0]?.['Provincia'],
                                                                fecha_inicio_prestamo_gastos: datos[1][0]?.['Fecha Inicio Prestamo'],
                                                                fecha_extrajudicial_gastos: datos[1][0]?.['Fecha Reclamacion Extrajudicial'],
                                                                nombre_y_apellidos_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                                notario_gastos: datos[1][0]?.['Notario'],
                                                                gastos_gestoria_gastos: datos[1][0]?.['Gastos Gestoria'],
                                                                gastos_notaria_gastos: datos[1][0]?.['Gastos Notaria'],
                                                                gastos_registro_gastos: datos[1][0]?.['Gastos Registro'],
                                                                gastos_tasacion_gastos: datos[1][0]?.['Gastos Tasacion'],
                                                                numero_negocio_gastos: datos[1][0]?.['Numero Negocio'],
                                                            });

                                                            // Actualizar banco y bancos absorbidos
                                                            updateBankAndAbsorbedBanks(bancoNombre);

                                                            handleChangeFechaInicioPrestamo({ target: { name: 'fecha_inicio_prestamo_gastos', value: datos[1]?.['Fecha Inicio Prestamo'] } });
                                                        }
                                                        if (datos[1].length > 1) {
                                                            setOpen(true);
                                                            //Juntar los datos de datos[0] con cada uno de los datos de datos[1]
                                                            let datosCompletos = []
                                                            datos[1].forEach((element) => {
                                                                let { Email, ...rest } = element; // Excluir Email de datos[1] (provisional) de cada elemento
                                                                datosCompletos.push({ ...datos[0], ...rest }) // Combinar datos[0] con el resto de cada elemento
                                                            })
                                                            setData(datosCompletos);
                                                        }
                                                    }
                                                } else {
                                                    toast.error(t("El DNI introducido no es válido"));
                                                }
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-span-2 sm:col-span-2" style={{ display: cantidadPersonasGE == 2 ? "block" : "none" }}>
                                    <label htmlFor="dni2_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">DNI 2 *</label>
                                    <input
                                        disabled={step1Loading}
                                        type="text"
                                        value={autoFill.dni2_gastos}
                                        name="dni2_gastos"
                                        id="dni2_gastos"
                                        autoComplete="dni2_gastos"
                                        className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder="DNI 2"
                                        onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        onBlur={async (e) => {
                                            if (validacionDNIoNIF(e.target.value)) {
                                                const datos = await buscarDNIEnBaserow(e.target.value, 'Gastos');

                                                if (datos && datos.length > 0) {

                                                    if (datos[1].length == 1 || datos[1].length == 0) {
                                                        // Rellenar el formulario con los datos
                                                        setAutoFill({
                                                            ...autoFill,
                                                            dni2_gastos: datos[0]?.['DNI'],
                                                            telefono2_gastos: datos[0]?.['Telefono'],
                                                            nombre_y_apellidos2_gastos: datos[0]?.['Nombre Y Apellidos'],
                                                        });
                                                    }
                                                    if (datos[1].length > 1) {
                                                        setOpen(true);
                                                        //Juntar los datos de datos[0] con cada uno de los datos de datos[1]
                                                        let datosCompletos = []
                                                        datos[1].forEach((element) => {
                                                            let { Email, ...rest } = element; // Excluir Email de cada elemento
                                                            datosCompletos.push({ ...datos[0], ...rest }) // Combinar datos[0] con el resto de cada elemento
                                                        })
                                                        setData(datosCompletos);
                                                    }
                                                }
                                            } else {
                                                toast.error(t("El DNI introducido no es válido"));
                                            }
                                        }}
                                    >
                                    </input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="nombre_y_apellidos_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Nombre y apellidos")} *</label>
                                    <input disabled={step1Loading} value={autoFill.nombre_y_apellidos_gastos} type="text" name="nombre_y_apellidos_gastos" id="nombre_y_apellidos_gastos" autoComplete="nombre_y_apellidos_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Nombre y Apellidos")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2" style={{ display: cantidadPersonasGE == 2 ? "block" : "none" }}>
                                    <label htmlFor="nombre_y_apellidos2_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Nombre y apellidos 2")}</label>
                                    <input disabled={step1Loading} value={autoFill.nombre_y_apellidos2_gastos} type="text" name="nombre_y_apellidos2_gastos" id="nombre_y_apellidos2_gastos" autoComplete="nombre_y_apellidos2_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} placeholder={t("Nombre y Apellidos 2")}></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="direccion_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Dirección")} *</label>
                                    <input disabled={step1Loading} ref={inputRef} value={autoFill.direccion_gastos} type="text" name="direccion_gastos" id="direccion_gastos" autoComplete="direccion_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Dirección")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="codigo_postal_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Código Postal")} *</label>
                                    <input disabled={step1Loading} ref={postalCodeRef} value={autoFill.codigo_postal_gastos} type="text" name="codigo_postal_gastos" id="codigo_postal_gastos" autoComplete="codigo_postal_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} placeholder={t("46011")} required></input>
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="provincia_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Provincia")} *</label>
                                    <input disabled={step1Loading} ref={provinciaRef} value={autoFill.provincia_gastos} type="text" name="provincia_gastos" id="provincia_gastos" autoComplete="provincia_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} placeholder={t("Valencia")} required></input>
                                </div>
                            </>
                        )}

                        {(!oneFile || formType !== 'demanda') && (
                            <>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="email_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">Email *</label>
                                    <input disabled={step1Loading} value={autoFill.email_gastos} type="email" name="email_gastos" id="email_gastos" autoComplete="email_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Email" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="telefono_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Teléfono")} *</label>
                                    <input disabled={step1Loading} value={autoFill.telefono_gastos} type="text" name="telefono_gastos" id="telefono_gastos" autoComplete="telefono_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        onBlur={(e) => { if (!validacionTelefono(e.target.value)) { alert("El teléfono no es válido") } }}
                                    />
                                </div>

                                <div className="col-span-2 sm:col-span-2" style={{ display: cantidadPersonasGE == 2 ? "block" : "none" }}>
                                    <label htmlFor="telefono2_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Teléfono 2")}</label>
                                    <input disabled={step1Loading} type="text" value={autoFill.telefono2_gastos} name="telefono2_gastos" id="telefono2_gastos" autoComplete="telefono2_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}></input>
                                </div>
                            </>
                        )}
                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="nprotocolo_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Nº de Protocolo")} *</label>
                            <input disabled={step1Loading} value={autoFill.nprotocolo_gastos} type="text" name="nprotocolo_gastos" id="nprotocolo_gastos" autoComplete="nprotocolo_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t('Nº de Protocolo')} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                        </div>
                        {formType === 'demanda' && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="clausula_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Cláusula")} *</label>
                                <input disabled={step1Loading} value={autoFill.clausula_gastos} type="text" name="clausula_gastos" id="clausula_gastos" autoComplete="clausula_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t('Cláusula')} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                <label htmlFor="clausula_texto_gastos" className="block text-sm mt-5 font-medium text-gray-700 dark:text-gray-400">{t("Texto de la cláusula")} *</label>
                                <textarea disabled={step1Loading} value={autoFill.clausula_texto_gastos} type="text" name="clausula_texto_gastos" id="clausula_texto_gastos" autoComplete="clausula_texto_gastos" className="mt-1 h-20 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t('Texto de la cláusula')} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></textarea>
                                
                                {/* Checkbox de cláusula suelo */}
                                <div className="mt-5">
                                    <label className="flex items-center cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-400" htmlFor="clausula_bis">
                                        <span className="mr-3">{t("Cláusula suelo")}</span>
                                        <div className="relative">
                                            <input disabled={step1Loading} checked={clausulaBis} type="checkbox" id="clausula_bis" name="clausula_bis" autoComplete="clausula_bis" className="sr-only peer" onChange={(e) => setClausulaBis(e.target.checked)} />
                                            <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:bg-blue-600"></div>
                                            <div className="absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition-all duration-200 peer-checked:left-6"></div>
                                        </div>
                                    </label>
                                </div>

                                {/* Campos de cláusula suelo - solo se muestran si el checkbox está marcado */}
                                {clausulaBis && (
                                    <>
                                        <label htmlFor="clausula_bis_gastos" className="block text-sm mt-5 font-medium text-gray-700 dark:text-gray-400">{t("Cláusula bis")} *</label>
                                        <input disabled={step1Loading} value={autoFill.clausula_bis_gastos} type="text" name="clausula_bis_gastos" id="clausula_bis_gastos" autoComplete="clausula_bis_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={'3 bis 3'} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required={clausulaBis}></input>
                                        <label htmlFor="clausula_bis_texto_gastos" className="block text-sm mt-5 font-medium text-gray-700 dark:text-gray-400">{t("Texto de la cláusula suelo")} *</label>
                                        <textarea disabled={step1Loading} value={autoFill.clausula_bis_texto_gastos} type="text" name="clausula_bis_texto_gastos" id="clausula_bis_texto_gastos" autoComplete="clausula_bis_texto_gastos" className="mt-1 h-20 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t('Texto de la cláusula suelo')} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required={clausulaBis}></textarea>
                                    </>
                                )}

                                {/* Input listado tipo_adiquisicion_gastos */}
                                <label htmlFor="tipo_adquisicion_gastos" className="block text-sm mt-5 font-medium text-gray-700 dark:text-gray-400">{t("Destino del Préstamo")} *</label>
                                <textarea
                                    disabled={step1Loading}
                                    value={autoFill.tipo_adquisicion_gastos}
                                    id="tipo_adquisicion_gastos"
                                    name="tipo_adquisicion_gastos"
                                    autoComplete="tipo_adquisicion_gastos"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-600 focus:border-primary-600 sm:text-sm dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    required
                                    onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                >
                                </textarea>
                            </div>
                        )}
                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="fecha_inicio_prestamo_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Fecha de inicio del préstamo")} *</label>
                            <input
                                disabled={step1Loading}
                                value={autoFill.fecha_inicio_prestamo_gastos}
                                type="date"
                                name="fecha_inicio_prestamo_gastos"
                                id="fecha_inicio_prestamo_gastos"
                                autoComplete="fecha_inicio_prestamo_gastos"
                                className={`mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    fechaError ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }`}
                                placeholder={t("Fecha de nacimiento")}
                                required
                                min="1900-01-01"
                                onChange={handleChangeFechaInicioPrestamo}
                                max={"2020-01-01"}
                            />
                            {fechaError && (
                                <p className="mt-2 text-sm text-red-600 dark:text-red-400">
                                    {fechaError}
                                </p>
                            )}
                        </div>
                        {formType === 'demanda' && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="fecha_extrajudicial_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Fecha reclamo extrajudicial")} *</label>
                                <input disabled={step1Loading} value={autoFill.fecha_extrajudicial_gastos} type="date" name="fecha_extrajudicial_gastos" id="fecha_extrajudicial_gastos" autoComplete="fecha_extrajudicial_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Fecha de nacimiento")} min="1900-01-01" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} max={new Date().toISOString().split("T")[0]} required></input>
                            </div>
                        )}
                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="notario_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Notario")} *</label>
                            <input disabled={step1Loading} value={autoFill.notario_gastos} type="text" name="notario_gastos" id="notario_gastos" autoComplete="notario_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("D. Fernando de Salas Moreno")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                        </div>

                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="banco_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Nombre del banco")} *</label>
                            <select onChange={handleBankChange} disabled={step1Loading} value={autoFill.banco_gastos} id="banco_gastos" name="banco_gastos" autoComplete="banco_gastos" className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-600 focus:border-primary-600 sm:text-sm dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required>
                                <option disabled value="">{t('Selecciona un banco')}</option>
                                {companies.map((company) => (
                                    <option key={company.name} value={company.name}>{company.name}</option>
                                ))}
                            </select>
                        </div>

                        {absorbedBanks.length > 0 && formType === 'demanda' && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="banco_absorbido_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Banco absorbido")}</label>
                                <select
                                    disabled={step1Loading}
                                    value={selectedAbsorbedBank}
                                    id="banco_absorbido_gastos"
                                    name="banco_absorbido_gastos"
                                    autoComplete="banco_absorbido_gastos"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-600 focus:border-primary-600 sm:text-sm dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    onChange={(e) => setSelectedAbsorbedBank(e.target.value)}
                                >
                                    <option value="">{t('Selecciona un banco absorbido (opcional)')}</option>
                                    {absorbedBanks.map((bank) => (
                                        <option key={bank} value={bank}>{bank}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {formType === 'demanda' && (
                            <>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="datos_banco_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Datos del banco")} *</label>
                                    <input value={selectedBank ? `CIF ${selectedBank.cif}, con domicilio social en ${selectedBank.address}` : ''} disabled={step1Loading} type="text" name="datos_banco_gastos" id="datos_banco_gastos" autoComplete="datos_banco_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Datos del banco")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                                </div>
                            </>
                        )}

                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="gastos_notaria_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Notaría (100%)")}</label>
                            <input disabled={step1Loading} type="number" value={autoFill.gastos_notaria_gastos} name="gastos_notaria_gastos" id="gastos_notaria_gastos" autoComplete="gastos_notaria_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" min={0} step="0.01"
                                onInput={(e) => {
                                    if (e.target.value < 0) {
                                        e.target.value = 0;
                                    } else {
                                        setAutoFill({ ...autoFill, [e.target.name]: e.target.value })
                                    }
                                }}>
                            </input>
                        </div>

                        {/* Si hay un archivo de notaria adicional, se muestra un input con el importe si existe o para rellenar */}
                        {notaryFileAdditional && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="gastos_notaria_gastos_adicional" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Notaría (adicional)")}</label>
                                <input disabled={step1Loading} type="number" value={autoFill.gastos_notaria_gastos_adicional} name="gastos_notaria_gastos_adicional" id="gastos_notaria_gastos_adicional" autoComplete="gastos_notaria_gastos_adicional" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" min={0} step="0.01"
                                    onInput={(e) => {
                                        if (e.target.value < 0) {
                                            e.target.value = 0;
                                        } else {
                                            setAutoFill({ ...autoFill, [e.target.name]: e.target.value })
                                        }
                                    }}>
                                </input>
                            </div>
                        )}

                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="gastos_registro_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Registro")} </label>
                            <input disabled={step1Loading} type="number" value={autoFill.gastos_registro_gastos} name="gastos_registro_gastos" id="gastos_registro_gastos" autoComplete="gastos_registro_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" step="0.01" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}></input>
                        </div>

                        {/* Checkbox de reparto de gastos - siempre aparece en demanda */}
                        {formType === 'demanda' && (
                            <div className="col-span-2 sm:col-span-2">
                                <label className="flex items-center cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-400" htmlFor="reparto_gastos">
                                    <span className="mr-3">{t("¿Hay reparto de gastos?")}</span>
                                    <div className="relative">
                                        <input disabled={step1Loading} checked={repartoGastos} type="checkbox" id="reparto_gastos" name="reparto_gastos" autoComplete="reparto_gastos" className="sr-only peer" onChange={(e) => setRepartoGastos(e.target.checked)} />
                                        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:bg-blue-600"></div>
                                        <div className="absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition-all duration-200 peer-checked:left-6"></div>
                                    </div>
                                </label>
                            </div>
                        )}

                        {/* Checkbox de certificado de cargas - solo aparece en demanda cuando gastos_registro_gastos > 0 */}
                        {formType === 'demanda' && Number(autoFill.gastos_registro_gastos) > 0 && (
                            <div className="col-span-2 sm:col-span-2">
                                <label className="flex items-center cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-400" htmlFor="certificado_cargas">
                                    <span className="mr-3">{t("Certificación de cargas")}</span>
                                    <div className="relative">
                                        <input disabled={step1Loading} checked={certificadoCargas} type="checkbox" id="certificado_cargas" name="certificado_cargas" autoComplete="certificado_cargas" className="sr-only peer" onChange={(e) => setCertificadoCargas(e.target.checked)} />
                                        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:bg-blue-600"></div>
                                        <div className="absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition-all duration-200 peer-checked:left-6"></div>
                                    </div>
                                </label>
                            </div>
                        )}

                        {/* Si hay un archivo de registro adicional, se muestra un input con el importe */}
                        {registryFileAdditional && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="gastos_registro_gastos_adicional" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Registro (adicional)")}</label>
                                <input disabled={step1Loading} type="number" value={autoFill.gastos_registro_gastos_adicional} name="gastos_registro_gastos_adicional" id="gastos_registro_gastos_adicional" autoComplete="gastos_registro_gastos_adicional" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" min={0} step="0.01"
                                    onInput={(e) => {
                                        if (e.target.value < 0) {
                                            e.target.value = 0;
                                        } else {
                                            setAutoFill({ ...autoFill, [e.target.name]: e.target.value })
                                        }
                                    }}>
                                </input>
                            </div>
                        )}

                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="gastos_gestoria_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Gestoría")} </label>
                            <input disabled={step1Loading} type="number" value={autoFill.gastos_gestoria_gastos} name="gastos_gestoria_gastos" id="gastos_gestoria_gastos" autoComplete="gastos_gestoria_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" step="0.01" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}></input>
                        </div>

                        {/* Si hay un archivo de gestoría adicional, se muestra un input con el importe */}
                        {agencyFileAdditional && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="gastos_gestoria_gastos_adicional" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Gestoría (adicional)")}</label>
                                <input disabled={step1Loading} type="number" value={autoFill.gastos_gestoria_gastos_adicional} name="gastos_gestoria_gastos_adicional" id="gastos_gestoria_gastos_adicional" autoComplete="gastos_gestoria_gastos_adicional" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" min={0} step="0.01"
                                    onInput={(e) => {
                                        if (e.target.value < 0) {
                                            e.target.value = 0;
                                        } else {
                                            setAutoFill({ ...autoFill, [e.target.name]: e.target.value })
                                        }
                                    }}>
                                </input>
                            </div>
                        )}

                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="gastos_tasacion_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Tasación")} </label>
                            <input disabled={step1Loading} type="number" value={autoFill.gastos_tasacion_gastos} name="gastos_tasacion_gastos" id="gastos_tasacion_gastos" autoComplete="gastos_tasacion_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" step="0.01" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}></input>

                            {/* Si hay un archivo de tasación adicional, se muestra un input con el importe */}
                            {appraisalFileAdditional && (
                                <div className="col-span-2 sm:col-span-2 mt-3">
                                    <label htmlFor="gastos_tasacion_gastos_adicional" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Gastos de Tasación (adicional)")}</label>
                                    <input disabled={step1Loading} type="number" value={autoFill.gastos_tasacion_gastos_adicional} name="gastos_tasacion_gastos_adicional" id="gastos_tasacion_gastos_adicional" autoComplete="gastos_tasacion_gastos_adicional" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" min={0} step="0.01"
                                        onInput={(e) => {
                                            if (e.target.value < 0) {
                                                e.target.value = 0;
                                            } else {
                                                setAutoFill({ ...autoFill, [e.target.name]: e.target.value })
                                            }
                                        }}>
                                    </input>
                                </div>
                            )}

                            {autoFill.gastos_tasacion_gastos > 0 && formType === 'demanda' && (
                                <>
                                    <label htmlFor="tasacion_bloque_gastos" className="block text-sm mt-5 font-medium text-gray-700 dark:text-gray-400">{t("Bloque tasación")} *</label>
                                    <textarea
                                        className="mt-5 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder="Tasación"
                                        name="tasacion_bloque_gastos"
                                        id="tasacion_bloque_gastos"
                                        value={`Honorarios profesionales por los servicios de tasación el inmueble: ${autoFill.gastos_tasacion_gastos}€ como se acredita mediante el documento adjunto al presente escrito en el ${autoFill.documento_tasacion_gastos}`}
                                        onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        required
                                    ></textarea>
                                </>
                            )}
                        </div>
                        <div className="col-span-2 sm:col-span-2">
                            <label htmlFor="porcentaje_cobro_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Porcentaje de cobro")} *</label>
                            <input disabled={step1Loading} type="number" value={autoFill.porcentaje_cobro_gastos} name="porcentaje_cobro_gastos" id="porcentaje_cobro_gastos" autoComplete="porcentaje_cobro_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                            <p id="helper-text-explanation" className="mt-2 text-sm text-gray-500 dark:text-gray-400">{t("Cambiar cuando sea distinto al 12%")}</p>
                        </div>
                        {formType === 'demanda' && (
                            <div className="col-span-2 sm:col-span-2">
                                <label htmlFor="total_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Total de gastos")} *</label>
                                <input disabled={true} type="number" value={autoFill.total_gastos} name="total_gastos" id="total_gastos" autoComplete="total_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="" step="0.01" onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} required></input>
                            </div>
                        )}
                        {formType === 'demanda' && (
                            <>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="juzgado_especifico_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Juzgado Específico")} *</label>
                                    <textarea
                                        disabled={step1Loading}
                                        value={autoFill.juzgado_especifico_gastos}
                                        type="text"
                                        name="juzgado_especifico_gastos"
                                        id="juzgado_especifico_gastos"
                                        autoComplete="juzgado_especifico_gastos"
                                        className="mt-1 h-20 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder={t("Juzgado Específico")}
                                        onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="documento_notaria_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Documento notaria")} </label>
                                    <input disabled={step1Loading} type="text" value={autoFill.documento_notaria_gastos} name="documento_notaria_gastos" id="documento_notaria_gastos" autoComplete="documento_notaria_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Documento número 3")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} ></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="documento_registro_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Documento registro")} </label>
                                    <input disabled={step1Loading} type="text" value={autoFill.documento_registro_gastos} name="documento_registro_gastos" id="documento_registro_gastos" autoComplete="documento_registro_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Documento número 4")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} ></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="documento_gestoria_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Documento gestoria")} </label>
                                    <input disabled={step1Loading} type="text" value={autoFill.documento_gestoria_gastos} name="documento_gestoria_gastos" id="documento_gestoria_gastos" autoComplete="documento_gestoria_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Documento número 5")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} ></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="documento_reclamacion_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Documento reclamación")} </label>
                                    <input disabled={step1Loading} type="text" value={autoFill.documento_reclamacion_gastos} name="documento_reclamacion_gastos" id="documento_reclamacion_gastos" autoComplete="documento_reclamacion_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Documento número 6")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} ></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="documento_extrajudicial_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Documento extrajudicial")} </label>
                                    <input disabled={step1Loading} type="text" value={autoFill.documento_extrajudicial_gastos} name="documento_extrajudicial_gastos" id="documento_extrajudicial_gastos" autoComplete="documento_extrajudicial_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Documento número 7")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} ></input>
                                </div>

                                <div className="col-span-2 sm:col-span-2">
                                    <label htmlFor="documento_tasacion_gastos" className="block text-sm font-medium text-gray-700 dark:text-gray-400">{t("Documento tasación")} </label>
                                    <input disabled={step1Loading} type="text" value={autoFill.documento_tasacion_gastos} name="documento_tasacion_gastos" id="documento_tasacion_gastos" autoComplete="documento_tasacion_gastos" className="mt-1 focus:ring-primary-600 focus:border-primary-600 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Documento número 8")} onChange={(e) => setAutoFill({ ...autoFill, [e.target.name]: e.target.value })} ></input>
                                </div>
                            </>
                        )}
                        {/* Cambiar, se renderiza solo en extrajudicial */}
                        {formType === 'extrajudicial' && (
                            <>
                                {/* Hacer que los DNI's sean FileInputWithCheckbox en lugar de inputs normales, con el renderizado condicional de la segunda persona */}
                                <FileInputWithCheckbox name="dni_front_gastos" id="dni_front_gastos" label={t("DNI Frontal" + (autoFill.nombre_y_apellidos_gastos ? " - " + autoFill.nombre_y_apellidos_gastos : ""))} setFile={setDniFrontFile} file={dniFrontFile} disabled={step1Loading} showAdditionalOption={false} />
                                <FileInputWithCheckbox name="dni_back_gastos" id="dni_back_gastos" label={t("DNI Trasero" + (autoFill.direccion_gastos ? " - " + autoFill.direccion_gastos : ""))} setFile={setDniBackFile} file={dniBackFile} disabled={step1Loading} showAdditionalOption={false} />
                                {cantidadPersonasGE == 2 && (
                                    <>
                                        <FileInputWithCheckbox name="dni_front2_gastos" id="dni_front2_gastos" label={t("DNI Frontal 2")} setFile={setDniFrontFile2} file={dniFrontFile2} disabled={step1Loading} showAdditionalOption={false} />
                                        <FileInputWithCheckbox name="dni_back2_gastos" id="dni_back2_gastos" label={t("DNI Trasero 2")} setFile={setDniBackFile2} file={dniBackFile2} disabled={step1Loading} showAdditionalOption={false} />
                                    </>
                                )}
                                {/* Archivos con opción a adicionar un archivo más */}
                                <FileInputWithCheckbox
                                    name="inotaria_gastos"
                                    id="inotaria_gastos"
                                    label={t("Imagen Notaría - " + (autoFill.gastos_notaria_gastos ? autoFill.gastos_notaria_gastos + "€" : "0€"))}
                                    setFile={setNotaryFile}
                                    file={notaryFile}
                                    disabled={step1Loading}
                                    showAdditionalOption={true}
                                    setAdditionalFile={setNotaryFileAdditional}
                                    additionalFile={notaryFileAdditional}
                                    additionalLabel={t("Imagen Notaría Adicional - " + (autoFill.gastos_notaria_gastos_adicional ? autoFill.gastos_notaria_gastos_adicional + "€" : "0€"))}
                                />
                                <FileInputWithCheckbox
                                    name="iregistro_gastos"
                                    id="iregistro_gastos"
                                    label={t("Imagen Registro - " + (autoFill.gastos_registro_gastos ? autoFill.gastos_registro_gastos + "€" : "0€"))}
                                    setFile={setRegistryFile}
                                    file={registryFile}
                                    disabled={step1Loading}
                                    showAdditionalOption={true}
                                    setAdditionalFile={setRegistryFileAdditional}
                                    additionalFile={registryFileAdditional}
                                    additionalLabel={t("Imagen Registro Adicional - " + (autoFill.gastos_registro_gastos_adicional ? autoFill.gastos_registro_gastos_adicional + "€" : "0€"))}
                                />
                                <FileInputWithCheckbox
                                    name="igestoria_gastos"
                                    id="igestoria_gastos"
                                    label={t("Imagen Gestoría - " + (autoFill.gastos_gestoria_gastos ? autoFill.gastos_gestoria_gastos + "€" : "0€"))}
                                    setFile={setAgencyFile}
                                    file={agencyFile}
                                    disabled={step1Loading}
                                    showAdditionalOption={true}
                                    setAdditionalFile={setAgencyFileAdditional}
                                    additionalFile={agencyFileAdditional}
                                    additionalLabel={t("Imagen Gestoría Adicional - " + (autoFill.gastos_gestoria_gastos_adicional ? autoFill.gastos_gestoria_gastos_adicional + "€" : "0€"))}
                                />
                                <FileInputWithCheckbox
                                    name="itasacion_gastos"
                                    id="itasacion_gastos"
                                    label={t("Imagen Tasación - " + (autoFill.gastos_tasacion_gastos ? autoFill.gastos_tasacion_gastos + "€" : "0€"))}
                                    setFile={setAppraisalFile}
                                    file={appraisalFile}
                                    disabled={step1Loading}
                                    showAdditionalOption={true}
                                    setAdditionalFile={setAppraisalFileAdditional}
                                    additionalFile={appraisalFileAdditional}
                                    additionalLabel={t("Imagen Tasación Adicional - " + (autoFill.gastos_tasacion_gastos_adicional ? autoFill.gastos_tasacion_gastos_adicional + "€" : "0€"))}
                                />
                            </>
                        )}
                        <div className={"col-span-2 sm:col-span-2 " + (step1Loading ? "hidden" : "")}>
                            <button 
                                type="submit" 
                                disabled={fechaError}
                                className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-4 focus:ring-primary-300 ${
                                    fechaError 
                                        ? 'bg-gray-400 cursor-not-allowed' 
                                        : 'bg-primary-600 hover:bg-primary-700'
                                }`}
                            >
                                {t("Siguiente")}
                            </button>
                        </div>
                        <div className={"col-span-2 sm:col-span-2 " + (step1Loading ? "" : "hidden")}>
                            <button disabled type="button" className={"w-full justify-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center"}>
                                <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                </svg>
                                {t('Cargando...')}
                            </button>
                        </div>
                    </div>
                </form >
            )}
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                transition
                className="fixed z-50 inset-0 overflow-y-auto sm:px-0 md:px-8 lg:px-16 xl:px-32 2xl:px-64 flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 bg-gray-500 bg-opacity-75 transition duration-300 ease-out data-[closed]:opacity-0 dark:bg-gray-900 dark:bg-opacity-75"
            >
                <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full dark:bg-gray-800 dark:text-gray-200">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 dark:bg-gray-800">
                        <div className="overflow-x-auto rounded-lg">
                            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-800 dark:text-gray-200">
                                    <tr>
                                        <th scope="col" className="px-4 py-3"></th>
                                        <th scope="col" className="px-4 py-3">DNI</th>
                                        <th scope="col" className="px-4 py-3">Nombre y Apellidos</th>
                                        <th scope="col" className="px-4 py-3">Email</th>
                                        <th scope="col" className="px-4 py-3">Teléfono</th>
                                        <th scope="col" className="px-4 py-3">Dirección</th>
                                        <th scope="col" className="px-4 py-3">Código Postal</th>
                                        <th scope="col" className="px-4 py-3">Fecha Inicio Préstamo</th>
                                        <th scope="col" className="px-4 py-3">Fecha Reclamación Extrajudicial</th>
                                        <th scope="col" className="px-4 py-3">Notario</th>
                                        <th scope="col" className="px-4 py-3">Provincia</th>
                                        <th scope="col" className="px-4 py-3">Banco</th>
                                        <th scope="col" className="px-4 py-3">Número Negocio</th>
                                        <th scope="col" className="px-4 py-3">Número Protocolo</th>
                                        <th scope="col" className="px-4 py-3">Gastos Notaría</th>
                                        <th scope="col" className="px-4 py-3">Gastos Registro</th>
                                        <th scope="col" className="px-4 py-3">Gastos Gestoría</th>
                                        <th scope="col" className="px-4 py-3">Gastos Tasación</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-700 rounded-xl">
                                    {data.map((item, index) => (
                                        <tr
                                            key={index}
                                            onClick={() => setSelectedRow(item)}
                                            className={selectedRow === item ? 'bg-blue-100 dark:bg-gray-700' : 'border-b dark:border-gray-700 hover:bg-gray-50 cursor-pointer dark:hover:bg-gray-700'}
                                        >
                                            <th scope="row" className="px-4 py-3 font-medium text-gray-900 dark:text-white flex items-center justify-center">
                                                <input type="radio" checked={selectedRow === item} className="text-primary-600" readOnly />
                                            </th>
                                            <th scope="row" className="px-4 py-3 font-medium text-gray-900 dark:text-white">{item['DNI']}</th>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Nombre Y Apellidos']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Email']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Telefono']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Direccion']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Codigo Postal']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Fecha Inicio Prestamo']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Fecha Reclamacion Extrajudicial']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Notario']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Provincia']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Banco']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Numero Negocio']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Numero Protocolo']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Gastos Notaria']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Gastos Registro']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Gastos Gestoria']}</td>
                                            <td className="px-4 py-3 dark:text-gray-400">{item['Gastos Tasacion']}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-gray-800">
                            <button
                                type="button"
                                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 sm:ml-3 sm:w-auto sm:text-sm"
                                onClick={() => {
                                    setOpen(false);
                                    setNumeroNegocioGastos(selectedRow['Numero Negocio']);
                                    setAutoFill({
                                        ...autoFill,
                                        dni_gastos: selectedRow['DNI'],
                                        email_gastos: selectedRow['Email'],
                                        telefono_gastos: selectedRow['Telefono'],
                                        fecha_inicio_prestamo_gastos: selectedRow['Fecha Inicio Prestamo'],
                                        fecha_extrajudicial_gastos: selectedRow['Fecha Reclamacion Extrajudicial'],
                                        notario_gastos: selectedRow['Notario'],
                                        nombre_y_apellidos_gastos: selectedRow['Nombre Y Apellidos'],
                                        direccion_gastos: selectedRow['Direccion'],
                                        codigo_postal_gastos: selectedRow['Codigo Postal'],
                                        nprotocolo_gastos: selectedRow['Numero Protocolo'],
                                        provincia_gastos: selectedRow['Provincia'],
                                        banco_gastos: selectedRow['Banco'],
                                        numero_negocio_gastos: selectedRow['Numero Negocio'],
                                        gastos_notaria_gastos: selectedRow['Gastos Notaria'],
                                        gastos_registro_gastos: selectedRow['Gastos Registro'],
                                        gastos_gestoria_gastos: selectedRow['Gastos Gestoria'],
                                        gastos_tasacion_gastos: selectedRow['Gastos Tasacion'],
                                    });
                                    handleChangeFechaInicioPrestamo({ target: { name: 'fecha_inicio_prestamo_gastos', value: selectedRow['Fecha Inicio Prestamo'] } });
                                }}
                            >
                                Seleccionar
                            </button>
                            <button
                                type="button"
                                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                onClick={() => setOpen(false)}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
            {
                step === 2 && (
                    <FormGastos2 setStep={setStep} setCurrentStep={setCurrentStep} step1Loading={step1Loading} apudFile={apudFile} setApudFile={setApudFile} contratoFile={contratoFile} setContratoFile={setContratoFile} reclamacionFile={reclamacionFile} setReclamacionFile={setReclamacionFile} formValues={formValues} hubspotData={hubspotData} documentoNotaria={notaryFile} documentoNotariaAdicional={notaryFileAdditional} documentoRegistro={registryFile} documentoRegistroAdicional={registryFileAdditional} documentoGestoría={agencyFile} documentoGestoríaAdicional={agencyFileAdditional} documentoTasación={appraisalFile} documentoTasaciónAdicional={appraisalFileAdditional} documentoDNIFront={dniFrontFile} documentoDNIBack={dniBackFile} documentoEscrituraHipotecaria={mortgageDeedFile} demandaGastos={formType === 'demanda'} />
                )
            }

            {/* Modal de confirmación de APUD */}
            <ApudConfirmationModal
                isOpen={showApudModal}
                onClose={handleApudModalClose}
                onConfirm={handleApudConfirm}
                onCancel={handleApudCancel}
            />
        </>
    )
}

FormGastos.propTypes = {
    step1Loading: propTypes.bool.isRequired,
    setStep1Loading: propTypes.func.isRequired,
    setCurrentStep: propTypes.func.isRequired,
}
